import { t as te } from "./module.esm-CVhmt7qZ.js";
import { t as En } from "./queueBounce-BYbNS_fP.js";
import { t as Jt } from "./morphNodes-CORZXiqO.js";
import { n as Sn, r as Tn, t as kn } from "./searchStore-Ct_MzZes.js";
var Cn = {
  "x-transition:enter": "transition-opacity ease-linear duration-300",
  "x-transition:enter-start": "opacity-0",
  "x-transition:enter-end": "opacity-100",
  "x-transition:leave": "transition-opacity ease-linear duration-300",
  "x-transition:leave-start": "opacity-100",
  "x-transition:leave-end": "opacity-0"
}, He = {
  "x-transition:enter": "transition ease-in-out duration-300 transform",
  "x-transition:enter-start": "-translate-x-full",
  "x-transition:enter-end": "translate-x-0",
  "x-transition:leave": "transition ease-in-out duration-300 transform",
  "x-transition:leave-start": "translate-x-0",
  "x-transition:leave-end": "-translate-x-full"
}, In = (t) => t.data("addressSwitch", ({ addresses: e }) => ({
  addresses: e,
  slideTransition: He,
  visibleForm: !1,
  currentlyEditedAddress: null,
  showForm() {
    this.visibleForm = !0;
  },
  editAddress(n) {
    this.visibleForm = !0, this.currentlyEditedAddress = this.addresses.find((i) => i.id === n), this.scrollFormIntoView();
  },
  cancelEdit() {
    this.visibleForm = !1, this.currentlyEditedAddress = null, this.scrollFormIntoView();
  },
  scrollFormIntoView() {
    window.matchMedia("(max-width: 1023px)").matches && document.querySelector(".address-form")?.scrollIntoView({ behavior: "smooth" });
  }
})), Nn = (t) => t.data("announcement", (e) => {
  const { settings: n } = e;
  return {
    current: 0,
    init() {
      n.auto_scroll && e.count > 0 && this.autoScroll(), this.$watch("current", (i) => this.autoScroll(i));
    },
    change(i) {
      this.current = i;
    },
    autoScroll(i = 0) {
      i >= e.count ? i = 0 : i += 1, setTimeout(() => this.change(i), n.delay * 1e3);
    },
    scrollThrough() {
      return {
        "x-transition:enter": "transition ease-in-out duration-300 transform absolute delay-300",
        "x-transition:enter-start": "-translate-y-full opacity-0",
        "x-transition:enter-end": "translate-y-0",
        "x-transition:leave": "transition ease-in-out duration-300 transform absolute",
        "x-transition:leave-start": "translate-y-0",
        "x-transition:leave-end": "translate-y-full opacity-0 "
      };
    }
  };
}), On = (t) => {
  t.data("backInStock", (e, n) => ({
    open: !1,
    sending: !1,
    sent: !1,
    query: {
      a: "Mtd5NY",
      g: "",
      email: "",
      variant: n,
      product: e,
      platform: "shopify",
      subscribe_for_newsletter: !1
    },
    get emailIsValid() {
      return /.+@.+\..+/.test(this.query.email);
    },
    get buttonLabel() {
      return this.sending ? "Sending..." : this.sent ? "Sent!" : "Notify Me When Available";
    },
    async submit() {
      if (!this.query.email) return;
      const i = "https://a.klaviyo.com/onsite/components/back-in-stock/subscribe", r = {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams(this.query)
      };
      this.sending = !0;
      try {
        const a = await fetch(i, r);
        if (!a.ok) throw new Error("Failed to subscribe");
        if (!(await a.json()).success) throw new Error("Failed to subscribe");
      } catch (a) {
        console.error(a);
      }
      this.sending = !1, this.sent = !0, setTimeout(() => this.open = !1, 2e3);
    }
  }));
}, Ln = (t) => {
  t.data("cardBadges", (e) => ({
    product: e,
    badgeRules: [],
    matched: null,
    init() {
      this.badgeRules = JSON.parse(this.$el.querySelector("script[data-badges]")?.textContent ?? "[]");
    },
    badgeFieldValue(n) {
      const i = this.product.additional_data || {};
      for (const r of n.keys || []) {
        const a = i[r], s = Array.isArray(a) ? a.find((o) => String(o).trim() !== "") : a;
        if (s != null && String(s).trim() !== "") return String(s).trim();
      }
      return "";
    },
    badgeLabel(n) {
      if (n.kind === "tag") return (this.product.tags || []).map((r) => String(r).trim().toLowerCase()).includes(n.tag) ? n.label : null;
      if (n.kind === "sold_out") return this.product.available === !1 ? n.label : null;
      const i = this.badgeFieldValue(n);
      return i === "" || i === "false" || i === "0" ? null : n.kind === "metafield_text" ? i : n.label;
    },
    resolveBadge() {
      for (const n of this.badgeRules) {
        const i = this.badgeLabel(n);
        if (i) return {
          ...n,
          label: i
        };
      }
      return null;
    }
  }));
}, ot = (t, e) => e instanceof t ? e : null, An = (t, e, n = 0) => Math.min(Math.max(t, n), e), xt = {}, _n = async (t) => {
  const e = t.toString();
  if (xt[e]) return xt[e];
  const n = await fetch(t);
  return n.ok ? (xt[e] = await n.text(), xt[e]) : null;
}, Fn = () => new Promise((t) => queueMicrotask(() => setTimeout(t, 0))), $n = (t, e, n = 0) => (t - n) % (e - n) + n, Rn = 5e3, Dn = (t) => t.data("cartDrawer", () => ({
  activeUpdates: 0,
  status: "",
  statusTimer: 0,
  giftDraft: null,
  init() {
    this.refresh = this.refresh.bind(this), this.updateItem = t.debounce(this.updateItem.bind(this), 500), this.$store.cart.addEventListener("open", this.refresh, { signal: this.$abortSignal }), this.$store.cart.addEventListener("load", this.refresh, { signal: this.$abortSignal });
  },
  async refresh() {
    const e = new URL(window.location.href), n = le();
    this.activeUpdates++, e.searchParams.set("sections", n.join(","));
    const i = await fetch(e);
    if (n.length && --this.activeUpdates == 0) {
      const r = await i.json();
      Jt(Object.values(r).join(""), []);
    }
  },
  close() {
    this.$store.cart.close();
  },
  async postCart(e, n, i = {}) {
    const r = i.swap !== !1, a = r ? le() : [];
    r && this.activeUpdates++;
    const s = await fetch(e, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(a.length ? {
        ...n,
        sections: a.join(",")
      } : n)
    }), o = await s.json().catch(() => ({}));
    if (!s.ok)
      throw r && this.activeUpdates--, new Error(String(o.description ?? o.message ?? s.statusText));
    return a.length && --this.activeUpdates == 0 && Jt(Object.values(o.sections ?? {}).join(""), []), o;
  },
  announce(e) {
    window.clearTimeout(this.statusTimer), this.status = "", this.$nextTick(() => {
      this.status = e, e && (this.statusTimer = window.setTimeout(() => {
        this.status = "";
      }, Rn));
    });
  },
  async removeItem(e) {
    await this.postCart("/cart/update.js", { updates: { [e]: 0 } });
  },
  async updateItem(e, n) {
    await this.postCart("/cart/update.js", { updates: { [e]: n } });
  },
  async changeItem(e, n) {
    await this.postCart("/cart/change.js", {
      id: e,
      properties: n
    });
  },
  async changeSellingPlan(e, n, i = 1) {
    await this.postCart("/cart/change.js", {
      id: e,
      selling_plan: n,
      quantity: i
    });
  }
})), le = () => {
  const t = Array.from(document.querySelectorAll(".shopify-section:has([data-oob-swap])"), (e) => e?.id.replace("shopify-section-", "") ?? "");
  return Array.from(new Set(t));
};
var ct = (t, e) => t.replace(/\[(\w+)\]/g, (n, i) => Object.hasOwn(e, i) ? String(e[i]) : n), ee = (t, e) => Object.fromEntries(t.map((n) => [n.key, (e[n.key] ?? "").trim()])), ce = (t, e, n) => {
  const i = ee(t, e), r = {};
  for (const a of t) {
    const s = i[a.key];
    a.required && s === "" ? r[a.key] = ct(n.requiredError, { label: a.label.toLowerCase() }) : a.limit > 0 && s.length > a.limit && (r[a.key] = ct(n.overLimitError, {
      label: a.label,
      count: s.length - a.limit,
      limit: a.limit
    }));
  }
  return r;
}, Mn = (t) => Math.max(1, Math.floor(t * 0.1)), Pn = (t, e, n) => {
  const i = e - t.length;
  return i < 0 ? ct(n.charsOver, { count: -i }) : i <= Mn(e) ? ct(n.charsRemainingLow, { count: i }) : ct(n.charsRemaining, { count: i });
}, qn = (t, e) => {
  const n = ee(t, e);
  return t.filter((i) => n[i.key] !== "").map((i) => `${i.label}: ${n[i.key]}`).join(`
`);
}, jn = (t) => Object.fromEntries(Object.entries(t).filter(([, e]) => e !== "")), Bn = (t, e, n) => {
  const i = ee(t, e), r = {
    path: "/cart/update.js",
    swap: !0,
    body: {
      attributes: i,
      ...n.copyToNote ? { note: qn(t, e) } : {}
    }
  };
  if (n.cardVariantId === null) return [r];
  const a = jn(i);
  return n.cardInCart && n.cardLineKey ? [{
    path: "/cart/change.js",
    swap: !1,
    body: {
      id: n.cardLineKey,
      quantity: n.cardQuantity,
      properties: a
    }
  }, r] : [{
    path: "/cart/add.js",
    swap: !1,
    body: { items: [{
      id: n.cardVariantId,
      quantity: 1,
      properties: a
    }] }
  }, r];
}, Hn = (t, e, n = null) => ({
  path: "/cart/update.js",
  swap: !0,
  body: {
    ...e.cardVariantId !== null && e.cardInCart ? { updates: { [e.cardVariantId]: 0 } } : {},
    attributes: Object.fromEntries(t.map((i) => [i.key, n])),
    ...e.copyToNote ? { note: "" } : {}
  }
}), K = (t) => t, ue = () => !!window.Shopify?.designMode, Vn = (t) => t.data("cartGiftMessage", (e) => ({
  open: !1,
  editing: !e.saved,
  card: e.cardInCart,
  saving: !1,
  error: "",
  values: {},
  errors: {},
  fields: [],
  lastAnnounced: {},
  counterTimer: 0,
  init() {
    const n = Array.from(this.$root.querySelectorAll("[data-gm-field]"));
    this.fields = n.map((a) => ({
      key: a.dataset.key ?? "",
      label: a.dataset.label ?? "",
      required: a.dataset.required === "true",
      limit: Number(a.dataset.limit ?? 0)
    }));
    const i = Object.fromEntries(n.map((a) => [a.dataset.key ?? "", a.querySelector("input, textarea")?.value ?? ""])), r = K(this).giftDraft;
    this.values = {
      ...i,
      ...r?.values ?? {}
    }, this.open = r?.open ?? e.editorOpen, this.editing = r?.editing ?? !e.saved, this.card = e.cardInCart ? !0 : r?.card ?? !1, this.error = r?.error ?? "";
  },
  context() {
    return {
      cardVariantId: e.cardVariantId,
      cardInCart: e.cardInCart,
      cardLineKey: e.cardLineKey,
      cardQuantity: e.cardQuantity,
      copyToNote: e.copyToNote
    };
  },
  control(n) {
    return Array.from(this.$root.querySelectorAll("[data-gm-field]")).find((i) => i.dataset.key === n)?.querySelector("input, textarea") ?? null;
  },
  focusKey(n) {
    this.$root.querySelector(`[data-focus-key="${n}"]`)?.focus();
  },
  focusFirstField() {
    const n = this.fields.find((i) => !this.control(i.key)?.disabled);
    n && this.control(n.key)?.focus();
  },
  persist() {
    K(this).giftDraft = {
      open: this.open,
      editing: this.editing,
      card: this.card,
      values: { ...this.values },
      error: this.error
    };
  },
  clearDraft() {
    K(this).giftDraft = null;
  },
  toggle() {
    this.open = !this.open, this.persist();
  },
  collapse() {
    if (e.saved && this.editing) {
      this.editing = !1, this.persist(), this.$nextTick(() => this.focusKey("gift-edit"));
      return;
    }
    this.open = !1, this.persist(), this.$nextTick(() => this.focusKey("gift-toggle"));
  },
  edit() {
    this.editing = !0, this.open = !0, this.persist(), this.$nextTick(() => this.focusFirstField());
  },
  onInput(n) {
    if (this.errors[n]) {
      const i = this.fields.find((a) => a.key === n), r = i ? ce([i], this.values, e.strings) : {};
      if (r[n])
        this.errors = {
          ...this.errors,
          [n]: r[n]
        };
      else {
        const { [n]: a, ...s } = this.errors;
        this.errors = s;
      }
    }
    this.persist(), this.scheduleCounterAnnouncement(n);
  },
  onCardChange() {
    if (!this.card) {
      const n = this.$root.querySelector("fieldset"), i = document.activeElement;
      n && i && n.contains(i) && this.$root.querySelector('input[type="checkbox"]')?.focus();
    }
    this.persist();
  },
  counterText(n, i) {
    return Pn(this.values[n] ?? "", i, e.strings);
  },
  describedBy(n, i, r) {
    const a = [i, this.errors[n] ? r : ""].filter(Boolean);
    return a.length ? a.join(" ") : null;
  },
  scheduleCounterAnnouncement(n) {
    const i = this.fields.find((r) => r.key === n);
    !i || i.limit <= 0 || (window.clearTimeout(this.counterTimer), this.counterTimer = window.setTimeout(() => {
      const r = i.limit - (this.values[n] ?? "").length, a = r <= 0 ? 0 : r <= 20 ? 20 : -1;
      if (a < 0 || this.lastAnnounced[n] === a) {
        a < 0 && delete this.lastAnnounced[n];
        return;
      }
      this.lastAnnounced[n] = a, K(this).announce(a === 0 ? e.strings.limitReached : ct(e.strings.charsRemaining, { count: r }));
    }, 500));
  },
  async save() {
    if (ue() || this.saving) return;
    this.error = "", this.errors = ce(this.fields, this.values, e.strings);
    const n = this.fields.find((a) => this.errors[a.key]);
    if (n) {
      this.$nextTick(() => this.control(n.key)?.focus());
      return;
    }
    const i = Bn(this.fields, this.values, this.context());
    this.saving = !0, K(this).giftDraft = {
      open: !0,
      editing: !1,
      card: !1,
      values: {},
      error: ""
    };
    let r = 0;
    try {
      for (const a of i)
        await K(this).postCart(a.path, a.body, { swap: a.swap }), r++;
      K(this).announce(e.cardVariantId !== null && !e.cardInCart ? e.strings.cardAdded : e.strings.saved);
    } catch {
      this.saving = !1, this.error = e.strings.error, this.persist(), r > 0 && i.length > 1 && await K(this).refresh();
    }
  },
  async remove() {
    if (ue() || this.saving) return;
    this.error = "", this.saving = !0, this.clearDraft();
    const n = Hn(this.fields, this.context());
    try {
      await K(this).postCart(n.path, n.body, { swap: n.swap }), K(this).announce(e.cardVariantId !== null && e.cardInCart ? e.strings.cardRemoved : e.strings.removed);
    } catch {
      this.saving = !1, this.error = e.strings.error, this.persist();
    }
  }
})), zn = (t) => t.data("collectionFilters", (e) => ({
  ...e,
  open: !1,
  fadeTransition: {
    "x-transition:enter": "transition-opacity ease-linear duration-300",
    "x-transition:enter-start": "opacity-0",
    "x-transition:enter-end": "opacity-100",
    "x-transition:leave": "transition-opacity ease-linear duration-300",
    "x-transition:leave-start": "opacity-100",
    "x-transition:leave-end": "opacity-0"
  },
  slideTransition: {
    "x-transition:enter": "transition ease-in-out duration-300 transform",
    "x-transition:enter-start": "-translate-x-full",
    "x-transition:enter-end": "translate-x-0",
    "x-transition:leave": "transition ease-in-out duration-300 transform",
    "x-transition:leave-start": "translate-x-0",
    "x-transition:leave-end": "-translate-x-full"
  }
})), Kn = (t) => t.data("detailsElement", () => ({
  isOpen: !1,
  theDetails: null,
  summaryElement: null,
  init() {
    this.summaryElement = this.$el.querySelector("summary"), this.summaryElement.setAttribute("aria-expanded", !1), this.summaryElement.setAttribute("aria-controls", this.$refs.contentElement.id), this.theDetails = this.$el, this.$watch("$store.mobileMenu.visible", (e) => !e && this.close());
  },
  open() {
    this.summaryElement.setAttribute("aria-expanded", !0), this.$nextTick(() => {
      this.isOpen = !0;
    });
  },
  cleanUp() {
    setTimeout(() => {
      this.theDetails.removeAttribute("open").then(() => this.isOpen = !1);
    }, 200);
  },
  close() {
    this.isOpen = !1, this.summaryElement.setAttribute("aria-expanded", !1), setTimeout(() => {
      this.theDetails.removeAttribute("open");
    }, 300);
  },
  detailsContent: {
    "x-show"() {
      return this.isOpen;
    },
    "x-transition:enter": "transition-transform",
    "x-transition:enter-start": "translate-x-full",
    "x-transition:leave": "transition-transform",
    "x-transition:leave-end": "translate-x-full"
  }
})), Wn = (t) => {
  t.addRootSelector(() => `[${t.prefixed("dynamic-image")}]`), t.addInitSelector(() => `[${t.prefixed("dynamic-image-broadcaster")}]`), t.directive("dynamic-image", ze), t.directive("dynamic-image-broadcaster", Un), t.directive("dynamic-image-image", Yn);
}, Ve = /* @__PURE__ */ new WeakMap(), ze = (t, e, { Alpine: n }) => {
  console.log("Setting up Dynamic Image Node");
  const i = Ve.get(t);
  if (!i) return console.error("Dynamic Image Failed to Register: ", t, e.value);
  n.addScopeToNode(t, i);
};
ze.inline = (t, e, { Alpine: n, cleanup: i }) => {
  console.log("Setting Dynamic Image Handler");
  const r = n.reactive({ image: null });
  Ve.set(t, r);
  const a = new AbortController();
  t.closest("section")?.addEventListener("dynamic-image-update", (s) => {
    console.log("Dynamic Image receiving Event"), r.image = s.detail;
  }, { signal: a.signal }), i(a.abort.bind(a));
};
var Un = (t, { value: e, expression: n, modifiers: i }, { Alpine: r, cleanup: a }) => {
  if (console.log("Setting up Dynamic Image Broadcaster"), e === "intersect") {
    console.log("Dynamic Image Root:", n);
    const s = new IntersectionObserver((o) => {
      for (const l of o) l.isIntersecting ? (console.log("Dynamic Image Broadcaster Intersecting "), Gn(t)) : console.log("Dynamic Image Broadcaster NOT Intersecting ");
    }, { rootMargin: n });
    i.includes("parent") && s.observe(t.parentElement), s.observe(t), a(s.disconnect.bind(s));
  }
}, Gn = (t) => {
  t.dispatchEvent(new CustomEvent("dynamic-image-update", {
    detail: JSON.parse(t.querySelector("script")?.textContent ?? "null"),
    bubbles: !0
  }));
}, Yn = (t, e, { Alpine: n, effect: i }) => {
  if (!(t instanceof HTMLTemplateElement)) return console.error("Dynamic Image Image must be Template Element");
  const r = t.content;
  let a = null;
  const s = n.$data(t);
  console.log("Registering Dynamic Image Effect"), i(() => {
    if (console.log("running Dynamic Image Effect"), "image" in s && s.image) {
      const o = s.image, l = document.importNode(r, !0).firstElementChild;
      if (!(l instanceof HTMLImageElement)) return console.error("Dynamic Image Template Must have an img child");
      if (n.bind(l, {
        "x-rias"() {
          return o.url;
        },
        width: o.width,
        height: o.height,
        alt: o.alt
      }), (a ?? t).after(l), new Animation(new KeyframeEffect(l, [{ opacity: "0" }, { opacity: "1" }], {
        duration: 500,
        fill: "both"
      })).play(), a) {
        const c = new Animation(new KeyframeEffect(a, [{ opacity: "1" }, { opacity: "0" }], {
          duration: 500,
          fill: "both",
          delay: 500
        }));
        c.play(), c.addEventListener("finish", a.remove.bind(a));
      }
      a = l;
    }
  });
}, Jn = (t) => t == null ? [] : Array.isArray(t) ? t.map((e) => Number(e)) : typeof t == "number" && !Number.isNaN(t) ? [t] : typeof t == "string" ? t.split(",").map((e) => e.trim()).filter(Boolean).map((e) => Number(e)) : [], Xn = (t) => t ? Array.isArray(t) ? t.map(String) : typeof t == "string" ? t.split(",").map((e) => e.trim()).filter(Boolean) : [] : [], Qn = (t) => t ? typeof t == "string" ? t : String(t) : "", Et = (t) => {
  const e = t ?? {};
  let n = Number(e.cutOffHour);
  Number.isFinite(n) || (n = 14);
  let i = Number(e.leadTime);
  return Number.isFinite(i) || (i = 0), {
    cutOffHour: n,
    leadTime: i,
    messageHtml: Qn(e.messageHtml),
    isCustomMessage: !!e.isCustomMessage,
    restrictedDays: Jn(e.restrictedDays),
    restrictedDates: Xn(e.restrictedDates)
  };
}, de = (t) => t.dayOfWeek % 7, Zn = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday"
], ti = (t) => {
  let e = Math.max(0, Math.floor(t));
  const n = Math.floor(e / 86400);
  e %= 86400;
  const i = Math.floor(e / 3600);
  return e %= 3600, {
    days: n,
    hours: i,
    minutes: Math.floor(e / 60),
    seconds: e % 60
  };
}, ei = (t) => {
  const e = t.dataset.esCfgId;
  if (!e) return Et(void 0);
  const n = document.getElementById(e);
  if (!n?.textContent?.trim()) return Et(void 0);
  try {
    const i = JSON.parse(n.textContent);
    return Et(i);
  } catch {
    return Et(void 0);
  }
}, Ut = "America/Chicago", ni = (t) => {
  t.data("estimatedShipping", (e = {}) => ({
    cutOffHour: 0,
    leadTime: 0,
    messageHtml: "",
    isCustomMessage: !1,
    restrictedDays: [],
    restrictedDates: [],
    message: "",
    intervalId: null,
    async init() {
      "Temporal" in globalThis || await import("./global.esm-ShPgAYTn.js"), Object.assign(this, ei(this.$el), e), this.tick(), this.intervalId = setInterval(() => this.tick(), 1e3);
    },
    destroy() {
      clearInterval(this.intervalId);
    },
    tick() {
      const n = Temporal.Now.zonedDateTimeISO(Ut), i = this.nextCutoffDate(), r = i.epochNanoseconds - n.epochNanoseconds, a = r <= 0n ? 0 : Number(r / 1000000000n), { days: s, hours: o, minutes: l, seconds: c } = ti(a), u = [];
      (u.length || s) && u.push(s === 1 ? `${s} day` : `${s} days`), (u.length || o) && u.push(o === 1 ? `${o} hour` : `${o} hours`), (u.length || l) && u.push(l === 1 ? `${l} minute` : `${l} minutes`), (u.length || c) && u.push(c === 1 ? `${c} second` : `${c} seconds`);
      const d = this.nextShippingDate(i), m = d.toPlainDate().equals(Temporal.Now.plainDateISO()) ? "Today" : Zn[de(d)];
      this.message = String(this.messageHtml).replace("%countdown%", u.join(", ")).replace("%ship_day%", m);
    },
    nextCutoffDate() {
      const n = Temporal.Now.zonedDateTimeISO(Ut);
      let i = Temporal.Now.zonedDateTimeISO(Ut).with({
        hour: this.cutOffHour,
        minute: 0,
        second: 0,
        millisecond: 0
      });
      for (Temporal.ZonedDateTime.compare(i, n) === -1 && (i = i.add({ days: 1 })); this.isDateRestricted(i); ) i = i.add({ days: 1 });
      return i;
    },
    nextShippingDate(n) {
      let i = n, r = this.leadTime;
      for (; this.isDateRestricted(i) || r > 0; )
        i = i.add({ days: 1 }), this.isDateRestricted(i) || r--;
      return i;
    },
    isDateRestricted(n) {
      if (this.restrictedDays.includes(de(n))) return !0;
      const i = n.toPlainDate().toString(), r = i.slice(5);
      return this.restrictedDates.some((a) => a === i || a === r);
    }
  }));
}, ii = (t) => {
  t.data("filterController", (i) => {
    const r = [];
    return i || console.error("No grid selector provided to filterController"), {
      forms: {},
      async init() {
        await t.nextTick(), this.facetChange(!1), r.push(t.effect(() => this.filterProducts())), window.addEventListener("popstate", this.updateFromHistory.bind(this));
      },
      updateFromHistory({ state: a }) {
        this.facetData = a ? JSON.parse(a) : this.facetChange();
        const s = this.facetData;
        document.querySelectorAll("#filter-drawer input[type=checkbox]").forEach((c) => {
          c.checked = s.some(([u, d]) => u === c.name && d === c.value);
        });
        const o = s.find(([c]) => c === "sort_by")?.[1];
        if (!o) return;
        const l = document.querySelector('select[name="sort_by"]');
        l && (l.value = o);
      },
      destroy() {
        r.forEach(t.release);
      },
      _expanded: [!0],
      expanded(a) {
        return this._expanded[a];
      },
      expand(a) {
        this._expanded[a] = !this._expanded[a];
      },
      open: !1,
      fadeTransition: Cn,
      slideTransition: He,
      facetData: [],
      facetChange(a = !0) {
        return this.facetData = Object.values(this.forms).flatMap((s) => Array.from(new FormData(s).entries())).filter(([s, o]) => !(s === "sort_by" && o === "manual" || s === "page" && (a || o === "1"))), this.facetData;
      },
      filterProducts() {
        n(this.facetData, i);
      },
      get isFiltered() {
        return this.facetData.some(([a]) => ![
          "type",
          "sort_by",
          "q"
        ].includes(a));
      }
    };
  });
  let e = !0;
  const n = En(async (i, r) => {
    const a = new URL(window.location.href);
    a.search = new URLSearchParams(i).toString();
    const s = await _n(a);
    if (!s) return;
    e || Jt(s, r);
    const o = a.toString() === window.location.href;
    history[e || o ? "replaceState" : "pushState"](JSON.stringify(i), "", a.toString()), e = !1;
  });
}, ri = (t) => {
  t.data("meganav", () => ({
    isVisible: !1,
    meganavIndex: 0,
    init() {
      this.meganavIndex = this.$store.meganavState.registerItem();
    },
    show() {
      this.isVisible = !0, this.$store.meganavState.items[this.meganavIndex] = !0;
    },
    hide() {
      this.isVisible = !1, this.$store.meganavState.items[this.meganavIndex] = !1;
    },
    toggle() {
      this.isVisible = !this.isVisible, t.nextTick(() => this.$store.meganavStateIsOpen = this.isVisible);
    },
    expand: {
      "@mouseover"() {
        this.show();
      },
      "@mouseleave"() {
        this.hide();
      },
      "@keydown.tab"() {
        this.$event.target.isSameNode(this.$focus.getLast()) && this.isVisible && !this.$event.shiftKey && (this.isVisible = !1);
      },
      "@keydown.shift.tab"() {
        this.$event.target.isSameNode(this.$focus.getFirst()) && this.isVisible && (this.isVisible = !1);
      },
      "@keydown.esc"() {
        this.$focus.getFirst().focus(), this.isVisible = !1;
      },
      "@keydown.down.prevent"() {
        this.$focus.wrap().next();
      },
      "@keydown.up.prevent"() {
        this.$focus.wrap().previous();
      }
    },
    fade: {
      "x-transition:enter": "transition-[top] duration-200",
      "x-transition:enter-start": "top-5",
      "x-transition:enter-end": "top-3",
      "x-transition:leave": "transition-[top] duration-200",
      "x-transition:leave-start": "top-3",
      "x-transition:leave-end": "top-5"
    }
  })), t.store("meganavState", {
    get isOpen() {
      return this.items.length ? this.items.some((e) => e) : !1;
    },
    items: [],
    registerItem() {
      return this.items.push(!1), this.items.length - 1;
    }
  });
}, ai = (t) => t.data("mobileMenu", () => ({
  size: "auto",
  adjustSize() {
    const e = this.$refs.menuDrawer;
    if (!e) return;
    const n = e.closest("section > :is(div.relative, div.absolute)");
    if (!n) return;
    const i = n.getBoundingClientRect(), r = i.y + i.height;
    this.size = `${r}px`;
  },
  adjustToLargestPart(e) {
    const n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT);
    let i = 0, r = e;
    do
      i = Math.max(i, r.scrollHeight);
    while (r = n.nextNode());
    this.size = `${i + 5}px`;
  },
  get isOpen() {
    return this.$nextTick(() => this.$dispatch("update-size")), this.$store.mobileMenu.visible;
  },
  open() {
    this.$store.mobileMenu.show();
  },
  close() {
    this.$store.mobileMenu.hide();
  },
  cleanUp() {
    this.$refs.menuDrawerList.querySelectorAll("details").forEach((e) => e.removeAttribute("open"));
  }
})), si = (t) => t.data("modal", () => ({
  isOpen: !1,
  init() {
    this.$watch("$store.modal.isOpen", (e) => {
      !e && this.close(!1);
    });
  },
  open() {
    this.$dispatch("nt:modal-open"), this.isOpen = !0, this.$store.modal.open();
  },
  close(e = !0) {
    this.$dispatch("nt:modal-close"), this.isOpen = !1, e && this.$store.modal.close();
  }
})), oi = (t) => {
  t.addRootSelector(() => `[${t.prefixed("panel-stack")}]`), t.directive("panel-stack", ci);
}, li = /* @__PURE__ */ new Set([
  "STYLE",
  "SCRIPT",
  "TEMPLATE",
  "LINK"
]), ci = (t, { expression: e }, { Alpine: n, effect: i, cleanup: r }) => {
  const a = n.reactive({ index: 0 }), s = new AbortController();
  r(s.abort.bind(s)), i(() => {
    const o = a.index;
    ui(t).forEach((l, c) => {
      l.classList.toggle("panel-current", c === o), l.classList.toggle("panel-previous", c < o), l.classList.toggle("panel-next", c > o), l.setAttribute("aria-hidden", String(c !== o));
    });
  }), queueMicrotask(() => {
    if (s.signal.aborted) return;
    const o = fi(t, e, di(n));
    o && (mi(o, t, a, s.signal, i), hi(o, t, a, n, i)), queueMicrotask(() => t.classList.add("panels-ready"));
  });
}, ui = (t) => Array.from(t.children).filter((e) => e instanceof HTMLElement && !li.has(e.tagName)), Ke = (t) => {
  const e = t.prefixed("accordion");
  return `[${e}], [${e}\\.open], [${e}\\.closed]`;
}, di = (t) => `[data-panel-trigger], ${Ke(t)}`, ne = (t, e, n) => Array.from(t.querySelectorAll(n)).filter((i) => !e.contains(i)), fi = (t, e, n) => {
  if (e) return t.closest(e) ?? document.querySelector(e);
  let i = t.parentElement;
  for (; i; ) {
    if (ne(i, t, n).length) return i;
    if (i.tagName === "SECTION") return null;
    i = i.parentElement;
  }
  return null;
}, hi = (t, e, n, i, r) => {
  ne(t, e, Ke(i)).map((a) => i.evaluate(a, "$accordion")).forEach((a, s) => {
    a && r(() => {
      a.active && (n.index = s);
    });
  });
}, mi = (t, e, n, i, r) => {
  const a = ne(t, e, "[data-panel-trigger]");
  if (!a.length) return;
  const s = a.map((o) => [o.dataset.panelTriggerTarget === "parent" ? o.parentElement ?? o : o, o.dataset.panelTrigger ?? "hover"]);
  s.forEach(([o, l], c) => {
    const u = () => {
      n.index = c;
    };
    l === "click" ? o.addEventListener("click", u, { signal: i }) : l === "hover" ? (o.addEventListener("pointerenter", u, { signal: i }), o.addEventListener("focusin", u, { signal: i })) : console.error("x-panel-trigger action: ", l, " is invalid. Use 'hover' or 'click'.");
  }), r(() => {
    const o = n.index;
    s.forEach(([l], c) => l.classList.toggle("trigger-current", c === o));
  });
}, vi = (t) => {
  t.data("productCard", (e) => ({
    variant: e,
    get image() {
      return this.variant.featuredImage;
    },
    get currentShade() {
      const { name: n, description: i, color: r } = this.variant;
      return {
        name: n,
        description: i,
        color: r
      };
    },
    get colorDisplay() {
      const { name: n } = this.variant;
      return `${n}`;
    },
    get queryString() {
      return `?variant=${this.variant.id}`;
    },
    setShade(n) {
      Object.assign(this, { variant: n });
    },
    get isOnSale() {
      return this.variant.price < (this.variant.compare_at_price ?? 0);
    }
  }));
}, We = class extends Error {
}, Gt = /* @__PURE__ */ new Map(), pi = (t) => typeof t == "string" ? t : t.name, gi = (t, e) => {
  const n = Gt.get(t);
  if (n) return n;
  const i = window.Shopify?.routes?.root ?? "/", r = fetch(`${i}products/${t}?view=quickadd`).then((a) => {
    if (a.status === 404) throw new We(t);
    if (!a.ok) throw new Error(`Quick add: ${a.status}`);
    return a.json();
  }).then((a) => ({
    optionNames: a.options.map(pi),
    variants: a.variants.map((s) => ({
      id: s.id,
      options: s.options,
      available: s.available,
      price: e(s.price / 100),
      label: s.label
    }))
  }));
  return r.catch(() => Gt.delete(t)), Gt.set(t, r), r;
}, bi = 500, yi = 5e3, wi = (t) => {
  t.data("quickAdd", (e) => ({
    text: e.text,
    title: e.title,
    label: e.label,
    soldOut: e.available === !1,
    handle: e.handle ?? null,
    variants: e.variants ?? [],
    optionNames: e.optionNames ?? [],
    open: !1,
    hasPanel: (e.variants ?? []).length > 1,
    step: 0,
    picked: [],
    busy: !1,
    pendingFocus: 0,
    loading: !1,
    status: "",
    error: "",
    requestId: 0,
    loadingTimer: 0,
    statusTimer: 0,
    get panelId() {
      return `quick-add-panel-${e.blockId}-${e.uid}`;
    },
    get scopeId() {
      return `shopify-block-${e.blockId}-${e.uid}`;
    },
    get loaded() {
      return this.variants.length > 0;
    },
    get isLast() {
      return this.step === this.optionNames.length - 1;
    },
    get optionName() {
      return this.optionNames[this.step] ?? "";
    },
    get panelLabel() {
      return this.optionName ? `${this.text.choose} — ${this.optionName}` : null;
    },
    get choices() {
      const n = this.variants.filter((r) => this.picked.every((a, s) => r.options[s] === a)), i = /* @__PURE__ */ new Map();
      return n.forEach((r) => {
        const a = r.options[this.step], s = i.get(a);
        if (s) {
          r.available && !s.available && Object.assign(s, {
            available: !0,
            id: r.id,
            price: r.price,
            label: this.labelFor(r, a)
          });
          return;
        }
        i.set(a, {
          value: a,
          options: r.options,
          available: r.available,
          id: r.id,
          price: r.price,
          label: this.labelFor(r, a)
        });
      }), this.withoutCollidingLabels(Array.from(i.values()));
    },
    labelFor(n, i) {
      return this.isLast && n.label || i;
    },
    withoutCollidingLabels(n) {
      const i = /* @__PURE__ */ new Map();
      return n.forEach((r) => {
        const a = r.label.trim().toLowerCase().replace(/\s+/g, " ");
        i.set(a, (i.get(a) ?? 0) + 1);
      }), n.map((r) => {
        const a = r.label.trim().toLowerCase().replace(/\s+/g, " ");
        return (i.get(a) ?? 0) < 2 ? r : {
          ...r,
          label: r.value
        };
      });
    },
    detail(n) {
      return n.available ? this.isLast ? n.price : "" : this.text.soldOut;
    },
    get alive() {
      return !!this.$root?.isConnected;
    },
    say(n) {
      window.clearTimeout(this.statusTimer), this.status = "", this.$nextTick(() => {
        this.alive && (this.status = n, n && (this.statusTimer = window.setTimeout(() => {
          this.status = "";
        }, yi)));
      });
    },
    focusMountedOption() {
      this.$nextTick(() => {
        this.alive && this.$refs.options?.querySelector("[data-quick-add-option]")?.focus();
      });
    },
    requestOptionFocus() {
      this.pendingFocus = this.requestId;
    },
    claimFocus(n) {
      this.pendingFocus && this.pendingFocus === this.requestId && this.open && this.$root?.contains(n) && (this.pendingFocus = 0, n.focus());
    },
    focusFirstOption() {
      if (this.$refs.options?.querySelector("[data-quick-add-option]")) {
        this.focusMountedOption();
        return;
      }
      this.requestOptionFocus();
    },
    reset() {
      this.step = 0, this.picked = [];
    },
    close(n) {
      this.open = !1, this.$refs.panel?.close(), this.pendingFocus = 0, this.reset(), n && this.alive && this.$refs.trigger?.focus();
    },
    back() {
      if (this.step === 0) {
        this.close(!0);
        return;
      }
      this.step = this.step - 1, this.picked = this.picked.slice(0, this.step), this.requestOptionFocus();
    },
    select(n) {
      if (n.available && this.loaded) {
        if (this.isLast) {
          this.add(n);
          return;
        }
        this.picked = this.picked.slice(0, this.step).concat(n.value), this.step = this.step + 1, this.requestOptionFocus();
      }
    },
    onEscape(n) {
      if (!this.open && !this.loading) return;
      n.stopPropagation();
      const i = this.open;
      this.requestId += 1, window.clearTimeout(this.loadingTimer), this.loading = !1, this.close(i || document.activeElement === document.body);
    },
    async ensureLoaded(n) {
      if (this.loaded) return !0;
      if (!this.handle) return !1;
      this.loading = !0, this.loadingTimer = window.setTimeout(() => {
        this.loading && this.requestId === n && this.say(this.text.loading);
      }, bi);
      try {
        const i = await gi(this.handle, this.$formatMoney);
        return this.requestId !== n || !this.alive ? !1 : (this.optionNames = i.optionNames, this.variants = i.variants, !0);
      } catch (i) {
        return this.requestId !== n || !this.alive || (i instanceof We ? this.say(this.text.unavailable.replace("[product]", () => this.title)) : this.error = this.text.loadFailed.replace("[product]", () => this.title)), !1;
      } finally {
        window.clearTimeout(this.loadingTimer), this.loading = !1;
      }
    },
    async activate() {
      if (this.busy || this.soldOut) return;
      if (this.open) {
        this.close(!1);
        return;
      }
      this.busy = !0, this.error = "";
      const n = this.requestId += 1;
      try {
        if (!await this.ensureLoaded(n)) return;
        if (!this.variants.some((i) => i.available)) {
          this.soldOut = !0, this.say(this.text.soldOutProduct.replace("[product]", () => this.title));
          return;
        }
        if (this.variants.length === 1) {
          await this.addVariant(this.variants[0].id, this.title);
          return;
        }
        if (this.reset(), this.hasPanel = !0, await this.$nextTick(), this.requestId !== n || !this.alive) return;
        this.open = !0, this.$refs.panel?.show(), document.activeElement === this.$refs.trigger ? this.focusFirstOption() : this.say(`${this.title}. ${this.panelLabel ?? ""}`);
      } finally {
        this.busy = !1;
      }
    },
    get cart() {
      return this.$store.cart;
    },
    get itemCount() {
      return this.cart.data.item_count ?? 0;
    },
    async syncCart() {
      this.cart.data.items || (this.cart.data = await this.cart.getState());
    },
    async add(n) {
      if (!this.busy) {
        this.busy = !0;
        try {
          await this.addVariant(n.id, n.value);
        } finally {
          this.busy = !1;
        }
      }
    },
    async addVariant(n, i) {
      this.error = "", this.say(this.text.adding), await this.syncCart();
      const r = this.itemCount;
      if (await this.cart.addItem(n), !!this.alive) {
        if (this.itemCount === r) {
          this.error = this.text.failed;
          return;
        }
        this.say(this.text.added.replace("[variant]", () => i)), this.close(!0), this.cart.open();
      }
    },
    destroy() {
      window.clearTimeout(this.loadingTimer), window.clearTimeout(this.statusTimer);
    }
  }));
}, xi = (t) => {
  t.data("quickOrder", (e) => ({
    removing: !1,
    get cart() {
      return this.$store.cart;
    },
    get productEntries() {
      return this.cart.items.filter((n) => n.product_id === e);
    },
    get quantity() {
      return this.productEntries.reduce((n, i) => n + i.quantity, 0);
    },
    get subtotal() {
      return this.$formatMoney(this.productEntries.reduce((n, i) => n + i.final_line_price, 0) / 100);
    },
    async removeAll() {
      this.removing = !0;
      for (const { id: n } of this.productEntries)
        await this.cart.removeItem(n), this.$dispatch("removeall", { id: n });
      this.removing = !1;
    }
  })), t.data("quickOrderRow", (e, n) => ({
    quantity: t.store("cart").items.find((i) => i.id === Number(e))?.quantity ?? 0,
    price: n,
    get priceDisplay() {
      return this.$formatMoney(this.price * this.quantity / 100);
    }
  })), t.data("quickQuantity", (e) => ({
    q: 0,
    get quant() {
      return this.q;
    },
    set quant(n) {
      n = Math.max(0, n), this.q = n;
    }
  }));
}, Ei = (t) => t.data("sizes", (e) => ({
  ...e,
  changeSize(n) {
    this.$dispatch("product-change", { product: n.product }), history.replaceState(null, n.product.title, n.url);
  }
})), Si = (t) => {
  t.data("stickyATC", () => ({
    show: !1,
    PDPATC: document.querySelector("#atc-button button[name=add]"),
    onScroll() {
      if (!this.PDPATC) return;
      const e = this.PDPATC.getBoundingClientRect();
      this.show = e.top < 25;
    }
  }));
}, Ti = (t) => {
  t.addRootSelector(() => `[${t.prefixed("stickyheader")}]`), t.directive("stickyheader", (e, n, { cleanup: i }) => {
    console.log("checking sticky header");
    const r = e.closest("section");
    if (!r || !("Animation" in globalThis)) return;
    console.log("setting up sticky header animation");
    const a = new Animation(new KeyframeEffect(r, [{ top: "0px" }, { get top() {
      return `-${e.clientHeight}px`;
    } }], {
      duration: 500,
      fill: "both"
    }));
    a.persist(), a.reverse(), a.finish();
    const s = t.effect(() => {
      const o = +(t.$scroll.direction === "down" && !t.$scroll.nearTop && !t.store("search").isOpen);
      a.playbackRate = o * 2 - 1;
    });
    i(() => t.release(s));
  });
}, ki = [
  In,
  Nn,
  Ln,
  Wn,
  ni,
  On,
  Dn,
  Vn,
  zn,
  Kn,
  ii,
  ri,
  ai,
  si,
  oi,
  vi,
  wi,
  xi,
  Ei,
  Si,
  Ti
], Ot = Math.min, it = Math.max, Lt = Math.round, St = Math.floor, Q = (t) => ({
  x: t,
  y: t
}), Ci = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, Ii = {
  start: "end",
  end: "start"
};
function fe(t, e, n) {
  return it(t, Ot(e, n));
}
function Pt(t, e) {
  return typeof t == "function" ? t(e) : t;
}
function rt(t) {
  return t.split("-")[0];
}
function qt(t) {
  return t.split("-")[1];
}
function Ue(t) {
  return t === "x" ? "y" : "x";
}
function Ge(t) {
  return t === "y" ? "height" : "width";
}
function jt(t) {
  return ["top", "bottom"].includes(rt(t)) ? "y" : "x";
}
function Ye(t) {
  return Ue(jt(t));
}
function Ni(t, e, n) {
  n === void 0 && (n = !1);
  const i = qt(t), r = Ye(t), a = Ge(r);
  let s = r === "x" ? i === (n ? "end" : "start") ? "right" : "left" : i === "start" ? "bottom" : "top";
  return e.reference[a] > e.floating[a] && (s = At(s)), [s, At(s)];
}
function Oi(t) {
  const e = At(t);
  return [
    Xt(t),
    e,
    Xt(e)
  ];
}
function Xt(t) {
  return t.replace(/start|end/g, (e) => Ii[e]);
}
function Li(t, e, n) {
  const i = ["left", "right"], r = ["right", "left"], a = ["top", "bottom"], s = ["bottom", "top"];
  switch (t) {
    case "top":
    case "bottom":
      return n ? e ? r : i : e ? i : r;
    case "left":
    case "right":
      return e ? a : s;
    default:
      return [];
  }
}
function Ai(t, e, n, i) {
  const r = qt(t);
  let a = Li(rt(t), n === "start", i);
  return r && (a = a.map((s) => s + "-" + r), e && (a = a.concat(a.map(Xt)))), a;
}
function At(t) {
  return t.replace(/left|right|bottom|top/g, (e) => Ci[e]);
}
function _i(t) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...t
  };
}
function Fi(t) {
  return typeof t != "number" ? _i(t) : {
    top: t,
    right: t,
    bottom: t,
    left: t
  };
}
function _t(t) {
  return {
    ...t,
    top: t.y,
    left: t.x,
    right: t.x + t.width,
    bottom: t.y + t.height
  };
}
function he(t, e, n) {
  let { reference: i, floating: r } = t;
  const a = jt(e), s = Ye(e), o = Ge(s), l = rt(e), c = a === "y", u = i.x + i.width / 2 - r.width / 2, d = i.y + i.height / 2 - r.height / 2, m = i[o] / 2 - r[o] / 2;
  let v;
  switch (l) {
    case "top":
      v = {
        x: u,
        y: i.y - r.height
      };
      break;
    case "bottom":
      v = {
        x: u,
        y: i.y + i.height
      };
      break;
    case "right":
      v = {
        x: i.x + i.width,
        y: d
      };
      break;
    case "left":
      v = {
        x: i.x - r.width,
        y: d
      };
      break;
    default:
      v = {
        x: i.x,
        y: i.y
      };
  }
  switch (qt(e)) {
    case "start":
      v[s] -= m * (n && c ? -1 : 1);
      break;
    case "end":
      v[s] += m * (n && c ? -1 : 1);
  }
  return v;
}
var $i = async (t, e, n) => {
  const { placement: i = "bottom", strategy: r = "absolute", middleware: a = [], platform: s } = n, o = a.filter(Boolean), l = await (s.isRTL == null ? void 0 : s.isRTL(e));
  let c = await s.getElementRects({
    reference: t,
    floating: e,
    strategy: r
  }), { x: u, y: d } = he(c, i, l), m = i, v = {}, p = 0;
  for (let b = 0; b < o.length; b++) {
    const { name: g, fn: w } = o[b], { x: C, y: O, data: _, reset: A } = await w({
      x: u,
      y: d,
      initialPlacement: i,
      placement: m,
      strategy: r,
      middlewareData: v,
      rects: c,
      platform: s,
      elements: {
        reference: t,
        floating: e
      }
    });
    if (u = C ?? u, d = O ?? d, v = {
      ...v,
      [g]: {
        ...v[g],
        ..._
      }
    }, A && p <= 50) {
      p++, typeof A == "object" && (A.placement && (m = A.placement), A.rects && (c = A.rects === !0 ? await s.getElementRects({
        reference: t,
        floating: e,
        strategy: r
      }) : A.rects), { x: u, y: d } = he(c, m, l)), b = -1;
      continue;
    }
  }
  return {
    x: u,
    y: d,
    placement: m,
    strategy: r,
    middlewareData: v
  };
};
async function Je(t, e) {
  var n;
  e === void 0 && (e = {});
  const { x: i, y: r, platform: a, rects: s, elements: o, strategy: l } = t, { boundary: c = "clippingAncestors", rootBoundary: u = "viewport", elementContext: d = "floating", altBoundary: m = !1, padding: v = 0 } = Pt(e, t), p = Fi(v), b = o[m ? d === "floating" ? "reference" : "floating" : d], g = _t(await a.getClippingRect({
    element: (n = await (a.isElement == null ? void 0 : a.isElement(b))) == null || n ? b : b.contextElement || await (a.getDocumentElement == null ? void 0 : a.getDocumentElement(o.floating)),
    boundary: c,
    rootBoundary: u,
    strategy: l
  })), w = d === "floating" ? {
    ...s.floating,
    x: i,
    y: r
  } : s.reference, C = await (a.getOffsetParent == null ? void 0 : a.getOffsetParent(o.floating)), O = await (a.isElement == null ? void 0 : a.isElement(C)) ? await (a.getScale == null ? void 0 : a.getScale(C)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, _ = _t(a.convertOffsetParentRelativeRectToViewportRelativeRect ? await a.convertOffsetParentRelativeRectToViewportRelativeRect({
    rect: w,
    offsetParent: C,
    strategy: l
  }) : w);
  return {
    top: (g.top - _.top + p.top) / O.y,
    bottom: (_.bottom - g.bottom + p.bottom) / O.y,
    left: (g.left - _.left + p.left) / O.x,
    right: (_.right - g.right + p.right) / O.x
  };
}
var Ri = function(t) {
  return t === void 0 && (t = {}), {
    name: "flip",
    options: t,
    async fn(e) {
      var n, i;
      const { placement: r, middlewareData: a, rects: s, initialPlacement: o, platform: l, elements: c } = e, { mainAxis: u = !0, crossAxis: d = !0, fallbackPlacements: m, fallbackStrategy: v = "bestFit", fallbackAxisSideDirection: p = "none", flipAlignment: b = !0, ...g } = Pt(t, e);
      if ((n = a.arrow) != null && n.alignmentOffset) return {};
      const w = rt(r), C = rt(o) === o, O = await (l.isRTL == null ? void 0 : l.isRTL(c.floating)), _ = m || (C || !b ? [At(o)] : Oi(o));
      !m && p !== "none" && _.push(...Ai(o, b, p, O));
      const A = [o, ..._], R = await Je(e, g), k = [];
      let F = ((i = a.flip) == null ? void 0 : i.overflows) || [];
      if (u && k.push(R[w]), d) {
        const S = Ni(r, s, O);
        k.push(R[S[0]], R[S[1]]);
      }
      if (F = [...F, {
        placement: r,
        overflows: k
      }], !k.every((S) => S <= 0)) {
        var z, U;
        const S = (((z = a.flip) == null ? void 0 : z.index) || 0) + 1, f = A[S];
        if (f) return {
          data: {
            index: S,
            overflows: F
          },
          reset: { placement: f }
        };
        let h = (U = F.filter((y) => y.overflows[0] <= 0).sort((y, E) => y.overflows[1] - E.overflows[1])[0]) == null ? void 0 : U.placement;
        if (!h) switch (v) {
          case "bestFit": {
            var M;
            const y = (M = F.map((E) => [E.placement, E.overflows.filter((x) => x > 0).reduce((x, N) => x + N, 0)]).sort((E, x) => E[1] - x[1])[0]) == null ? void 0 : M[0];
            y && (h = y);
            break;
          }
          case "initialPlacement":
            h = o;
        }
        if (r !== h) return { reset: { placement: h } };
      }
      return {};
    }
  };
};
async function Di(t, e) {
  const { placement: n, platform: i, elements: r } = t, a = await (i.isRTL == null ? void 0 : i.isRTL(r.floating)), s = rt(n), o = qt(n), l = jt(n) === "y", c = ["left", "top"].includes(s) ? -1 : 1, u = a && l ? -1 : 1, d = Pt(e, t);
  let { mainAxis: m, crossAxis: v, alignmentAxis: p } = typeof d == "number" ? {
    mainAxis: d,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: 0,
    crossAxis: 0,
    alignmentAxis: null,
    ...d
  };
  return o && typeof p == "number" && (v = o === "end" ? p * -1 : p), l ? {
    x: v * u,
    y: m * c
  } : {
    x: m * c,
    y: v * u
  };
}
var Mi = function(t) {
  return t === void 0 && (t = 0), {
    name: "offset",
    options: t,
    async fn(e) {
      const { x: n, y: i } = e, r = await Di(e, t);
      return {
        x: n + r.x,
        y: i + r.y,
        data: r
      };
    }
  };
}, Pi = function(t) {
  return t === void 0 && (t = {}), {
    name: "shift",
    options: t,
    async fn(e) {
      const { x: n, y: i, placement: r } = e, { mainAxis: a = !0, crossAxis: s = !1, limiter: o = { fn: (g) => {
        let { x: w, y: C } = g;
        return {
          x: w,
          y: C
        };
      } }, ...l } = Pt(t, e), c = {
        x: n,
        y: i
      }, u = await Je(e, l), d = jt(rt(r)), m = Ue(d);
      let v = c[m], p = c[d];
      if (a) {
        const g = m === "y" ? "top" : "left", w = m === "y" ? "bottom" : "right", C = v + u[g], O = v - u[w];
        v = fe(C, v, O);
      }
      if (s) {
        const g = d === "y" ? "top" : "left", w = d === "y" ? "bottom" : "right", C = p + u[g], O = p - u[w];
        p = fe(C, p, O);
      }
      const b = o.fn({
        ...e,
        [m]: v,
        [d]: p
      });
      return {
        ...b,
        data: {
          x: b.x - n,
          y: b.y - i
        }
      };
    }
  };
};
function Z(t) {
  return Xe(t) ? (t.nodeName || "").toLowerCase() : "#document";
}
function H(t) {
  var e;
  return (t == null || (e = t.ownerDocument) == null ? void 0 : e.defaultView) || window;
}
function J(t) {
  var e;
  return (e = (Xe(t) ? t.ownerDocument : t.document) || window.document) == null ? void 0 : e.documentElement;
}
function Xe(t) {
  return t instanceof Node || t instanceof H(t).Node;
}
function Y(t) {
  return t instanceof Element || t instanceof H(t).Element;
}
function W(t) {
  return t instanceof HTMLElement || t instanceof H(t).HTMLElement;
}
function me(t) {
  return typeof ShadowRoot > "u" ? !1 : t instanceof ShadowRoot || t instanceof H(t).ShadowRoot;
}
function wt(t) {
  const { overflow: e, overflowX: n, overflowY: i, display: r } = V(t);
  return /auto|scroll|overlay|hidden|clip/.test(e + i + n) && !["inline", "contents"].includes(r);
}
function qi(t) {
  return [
    "table",
    "td",
    "th"
  ].includes(Z(t));
}
function ie(t) {
  const e = re(), n = V(t);
  return n.transform !== "none" || n.perspective !== "none" || (n.containerType ? n.containerType !== "normal" : !1) || !e && (n.backdropFilter ? n.backdropFilter !== "none" : !1) || !e && (n.filter ? n.filter !== "none" : !1) || [
    "transform",
    "perspective",
    "filter"
  ].some((i) => (n.willChange || "").includes(i)) || [
    "paint",
    "layout",
    "strict",
    "content"
  ].some((i) => (n.contain || "").includes(i));
}
function ji(t) {
  let e = dt(t);
  for (; W(e) && !Bt(e); ) {
    if (ie(e)) return e;
    e = dt(e);
  }
  return null;
}
function re() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function Bt(t) {
  return [
    "html",
    "body",
    "#document"
  ].includes(Z(t));
}
function V(t) {
  return H(t).getComputedStyle(t);
}
function Ht(t) {
  return Y(t) ? {
    scrollLeft: t.scrollLeft,
    scrollTop: t.scrollTop
  } : {
    scrollLeft: t.pageXOffset,
    scrollTop: t.pageYOffset
  };
}
function dt(t) {
  if (Z(t) === "html") return t;
  const e = t.assignedSlot || t.parentNode || me(t) && t.host || J(t);
  return me(e) ? e.host : e;
}
function Qe(t) {
  const e = dt(t);
  return Bt(e) ? t.ownerDocument ? t.ownerDocument.body : t.body : W(e) && wt(e) ? e : Qe(e);
}
function gt(t, e, n) {
  var i;
  e === void 0 && (e = []), n === void 0 && (n = !0);
  const r = Qe(t), a = r === ((i = t.ownerDocument) == null ? void 0 : i.body), s = H(r);
  return a ? e.concat(s, s.visualViewport || [], wt(r) ? r : [], s.frameElement && n ? gt(s.frameElement) : []) : e.concat(r, gt(r, [], n));
}
function Ze(t) {
  const e = V(t);
  let n = parseFloat(e.width) || 0, i = parseFloat(e.height) || 0;
  const r = W(t), a = r ? t.offsetWidth : n, s = r ? t.offsetHeight : i, o = Lt(n) !== a || Lt(i) !== s;
  return o && (n = a, i = s), {
    width: n,
    height: i,
    $: o
  };
}
function ae(t) {
  return Y(t) ? t : t.contextElement;
}
function ut(t) {
  const e = ae(t);
  if (!W(e)) return Q(1);
  const n = e.getBoundingClientRect(), { width: i, height: r, $: a } = Ze(e);
  let s = (a ? Lt(n.width) : n.width) / i, o = (a ? Lt(n.height) : n.height) / r;
  return (!s || !Number.isFinite(s)) && (s = 1), (!o || !Number.isFinite(o)) && (o = 1), {
    x: s,
    y: o
  };
}
var Bi = /* @__PURE__ */ Q(0);
function tn(t) {
  const e = H(t);
  return !re() || !e.visualViewport ? Bi : {
    x: e.visualViewport.offsetLeft,
    y: e.visualViewport.offsetTop
  };
}
function Hi(t, e, n) {
  return e === void 0 && (e = !1), !n || e && n !== H(t) ? !1 : e;
}
function at(t, e, n, i) {
  e === void 0 && (e = !1), n === void 0 && (n = !1);
  const r = t.getBoundingClientRect(), a = ae(t);
  let s = Q(1);
  e && (i ? Y(i) && (s = ut(i)) : s = ut(t));
  const o = Hi(a, n, i) ? tn(a) : Q(0);
  let l = (r.left + o.x) / s.x, c = (r.top + o.y) / s.y, u = r.width / s.x, d = r.height / s.y;
  if (a) {
    const m = H(a), v = i && Y(i) ? H(i) : i;
    let p = m.frameElement;
    for (; p && i && v !== m; ) {
      const b = ut(p), g = p.getBoundingClientRect(), w = V(p), C = g.left + (p.clientLeft + parseFloat(w.paddingLeft)) * b.x, O = g.top + (p.clientTop + parseFloat(w.paddingTop)) * b.y;
      l *= b.x, c *= b.y, u *= b.x, d *= b.y, l += C, c += O, p = H(p).frameElement;
    }
  }
  return _t({
    width: u,
    height: d,
    x: l,
    y: c
  });
}
function Vi(t) {
  let { rect: e, offsetParent: n, strategy: i } = t;
  const r = W(n), a = J(n);
  if (n === a) return e;
  let s = {
    scrollLeft: 0,
    scrollTop: 0
  }, o = Q(1);
  const l = Q(0);
  if ((r || !r && i !== "fixed") && ((Z(n) !== "body" || wt(a)) && (s = Ht(n)), W(n))) {
    const c = at(n);
    o = ut(n), l.x = c.x + n.clientLeft, l.y = c.y + n.clientTop;
  }
  return {
    width: e.width * o.x,
    height: e.height * o.y,
    x: e.x * o.x - s.scrollLeft * o.x + l.x,
    y: e.y * o.y - s.scrollTop * o.y + l.y
  };
}
function zi(t) {
  return Array.from(t.getClientRects());
}
function en(t) {
  return at(J(t)).left + Ht(t).scrollLeft;
}
function Ki(t) {
  const e = J(t), n = Ht(t), i = t.ownerDocument.body, r = it(e.scrollWidth, e.clientWidth, i.scrollWidth, i.clientWidth), a = it(e.scrollHeight, e.clientHeight, i.scrollHeight, i.clientHeight);
  let s = -n.scrollLeft + en(t);
  const o = -n.scrollTop;
  return V(i).direction === "rtl" && (s += it(e.clientWidth, i.clientWidth) - r), {
    width: r,
    height: a,
    x: s,
    y: o
  };
}
function Wi(t, e) {
  const n = H(t), i = J(t), r = n.visualViewport;
  let a = i.clientWidth, s = i.clientHeight, o = 0, l = 0;
  if (r) {
    a = r.width, s = r.height;
    const c = re();
    (!c || c && e === "fixed") && (o = r.offsetLeft, l = r.offsetTop);
  }
  return {
    width: a,
    height: s,
    x: o,
    y: l
  };
}
function Ui(t, e) {
  const n = at(t, !0, e === "fixed"), i = n.top + t.clientTop, r = n.left + t.clientLeft, a = W(t) ? ut(t) : Q(1);
  return {
    width: t.clientWidth * a.x,
    height: t.clientHeight * a.y,
    x: r * a.x,
    y: i * a.y
  };
}
function ve(t, e, n) {
  let i;
  if (e === "viewport") i = Wi(t, n);
  else if (e === "document") i = Ki(J(t));
  else if (Y(e)) i = Ui(e, n);
  else {
    const r = tn(t);
    i = {
      ...e,
      x: e.x - r.x,
      y: e.y - r.y
    };
  }
  return _t(i);
}
function nn(t, e) {
  const n = dt(t);
  return n === e || !Y(n) || Bt(n) ? !1 : V(n).position === "fixed" || nn(n, e);
}
function Gi(t, e) {
  const n = e.get(t);
  if (n) return n;
  let i = gt(t, [], !1).filter((o) => Y(o) && Z(o) !== "body"), r = null;
  const a = V(t).position === "fixed";
  let s = a ? dt(t) : t;
  for (; Y(s) && !Bt(s); ) {
    const o = V(s), l = ie(s);
    !l && o.position === "fixed" && (r = null), (a ? !l && !r : !l && o.position === "static" && r && ["absolute", "fixed"].includes(r.position) || wt(s) && !l && nn(t, s)) ? i = i.filter((c) => c !== s) : r = o, s = dt(s);
  }
  return e.set(t, i), i;
}
function Yi(t) {
  let { element: e, boundary: n, rootBoundary: i, strategy: r } = t;
  const a = [...n === "clippingAncestors" ? Gi(e, this._c) : [].concat(n), i], s = a[0], o = a.reduce((l, c) => {
    const u = ve(e, c, r);
    return l.top = it(u.top, l.top), l.right = Ot(u.right, l.right), l.bottom = Ot(u.bottom, l.bottom), l.left = it(u.left, l.left), l;
  }, ve(e, s, r));
  return {
    width: o.right - o.left,
    height: o.bottom - o.top,
    x: o.left,
    y: o.top
  };
}
function Ji(t) {
  return Ze(t);
}
function Xi(t, e, n) {
  const i = W(e), r = J(e), a = n === "fixed", s = at(t, !0, a, e);
  let o = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const l = Q(0);
  if (i || !i && !a)
    if ((Z(e) !== "body" || wt(r)) && (o = Ht(e)), i) {
      const c = at(e, !0, a, e);
      l.x = c.x + e.clientLeft, l.y = c.y + e.clientTop;
    } else r && (l.x = en(r));
  return {
    x: s.left + o.scrollLeft - l.x,
    y: s.top + o.scrollTop - l.y,
    width: s.width,
    height: s.height
  };
}
function pe(t, e) {
  return !W(t) || V(t).position === "fixed" ? null : e ? e(t) : t.offsetParent;
}
function rn(t, e) {
  const n = H(t);
  if (!W(t)) return n;
  let i = pe(t, e);
  for (; i && qi(i) && V(i).position === "static"; ) i = pe(i, e);
  return i && (Z(i) === "html" || Z(i) === "body" && V(i).position === "static" && !ie(i)) ? n : i || ji(t) || n;
}
var Qi = async function(t) {
  let { reference: e, floating: n, strategy: i } = t;
  const r = this.getOffsetParent || rn, a = this.getDimensions;
  return {
    reference: Xi(e, await r(n), i),
    floating: {
      x: 0,
      y: 0,
      ...await a(n)
    }
  };
};
function Zi(t) {
  return V(t).direction === "rtl";
}
var tr = {
  convertOffsetParentRelativeRectToViewportRelativeRect: Vi,
  getDocumentElement: J,
  getClippingRect: Yi,
  getOffsetParent: rn,
  getElementRects: Qi,
  getClientRects: zi,
  getDimensions: Ji,
  getScale: ut,
  isElement: Y,
  isRTL: Zi
};
function er(t, e) {
  let n = null, i;
  const r = J(t);
  function a() {
    clearTimeout(i), n && n.disconnect(), n = null;
  }
  function s(o, l) {
    o === void 0 && (o = !1), l === void 0 && (l = 1), a();
    const { left: c, top: u, width: d, height: m } = t.getBoundingClientRect();
    if (o || e(), !d || !m) return;
    const v = St(u), p = St(r.clientWidth - (c + d)), b = St(r.clientHeight - (u + m)), g = St(c), w = {
      rootMargin: -v + "px " + -p + "px " + -b + "px " + -g + "px",
      threshold: it(0, Ot(1, l)) || 1
    };
    let C = !0;
    function O(_) {
      const A = _[0].intersectionRatio;
      if (A !== l) {
        if (!C) return s();
        A ? s(!1, A) : i = setTimeout(() => {
          s(!1, 1e-7);
        }, 100);
      }
      C = !1;
    }
    try {
      n = new IntersectionObserver(O, {
        ...w,
        root: r.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(O, w);
    }
    n.observe(t);
  }
  return s(!0), a;
}
function nr(t, e, n, i) {
  i === void 0 && (i = {});
  const { ancestorScroll: r = !0, ancestorResize: a = !0, elementResize: s = typeof ResizeObserver == "function", layoutShift: o = typeof IntersectionObserver == "function", animationFrame: l = !1 } = i, c = ae(t), u = r || a ? [...c ? gt(c) : [], ...gt(e)] : [];
  u.forEach((w) => {
    r && w.addEventListener("scroll", n, { passive: !0 }), a && w.addEventListener("resize", n);
  });
  const d = c && o ? er(c, n) : null;
  let m = -1, v = null;
  s && (v = new ResizeObserver((w) => {
    let [C] = w;
    C && C.target === c && v && (v.unobserve(e), cancelAnimationFrame(m), m = requestAnimationFrame(() => {
      v && v.observe(e);
    })), n();
  }), c && !l && v.observe(c), v.observe(e));
  let p, b = l ? at(t) : null;
  l && g();
  function g() {
    const w = at(t);
    b && (w.x !== b.x || w.y !== b.y || w.width !== b.width || w.height !== b.height) && n(), b = w, p = requestAnimationFrame(g);
  }
  return n(), () => {
    u.forEach((w) => {
      r && w.removeEventListener("scroll", n), a && w.removeEventListener("resize", n);
    }), d && d(), v && v.disconnect(), v = null, l && cancelAnimationFrame(p);
  };
}
var ir = (t, e, n) => {
  const i = /* @__PURE__ */ new Map(), r = {
    platform: tr,
    ...n
  }, a = {
    ...r.platform,
    _c: i
  };
  return $i(t, e, {
    ...r,
    platform: a
  });
};
function rr(t) {
  t.magic("anchor", (e) => {
    if (!e._x_anchor) throw "Alpine: No x-anchor directive found on element using $anchor...";
    return e._x_anchor;
  }), t.interceptClone((e, n) => {
    e && e._x_anchor && !n._x_anchor && (n._x_anchor = e._x_anchor);
  }), t.directive("anchor", t.skipDuringClone((e, { expression: n, modifiers: i, value: r }, { evaluate: a, effect: s, cleanup: o }) => {
    let { placement: l, offsetValue: c, unstyled: u, strategy: d, allowFlip: m } = be(i);
    e._x_anchor = t.reactive({
      x: 0,
      y: 0
    });
    let v = null, p = null;
    s(() => {
      let b = a(n);
      if (b && v !== b) {
        p && p(), v = b;
        let g = () => {
          let w;
          ir(b, e, {
            placement: l,
            strategy: d,
            middleware: [
              m && Ri(),
              Pi({ padding: 5 }),
              Mi(c)
            ]
          }).then(({ x: C, y: O }) => {
            u || ge(e, C, O, d), JSON.stringify({
              x: C,
              y: O
            }) !== w && (e._x_anchor.x = C, e._x_anchor.y = O), w = JSON.stringify({
              x: C,
              y: O
            });
          });
        };
        p = nr(b, e, () => g());
      }
    }), o(() => {
      p && p();
    });
  }, (e, { expression: n, modifiers: i, value: r }, { cleanup: a, evaluate: s }) => {
    let { placement: o, offsetValue: l, unstyled: c, strategy: u } = be(i);
    e._x_anchor && (c || ge(e, e._x_anchor.x, e._x_anchor.y, u));
  }));
}
function ge(t, e, n, i = "absolute") {
  Object.assign(t.style, {
    left: e + "px",
    top: n + "px",
    position: i
  });
}
function be(t) {
  let e = [
    "top",
    "top-start",
    "top-end",
    "right",
    "right-start",
    "right-end",
    "bottom",
    "bottom-start",
    "bottom-end",
    "left",
    "left-start",
    "left-end"
  ].find((s) => t.includes(s)), n = 0;
  if (t.includes("offset")) {
    let s = t.findIndex((o) => o === "offset");
    n = t[s + 1] !== void 0 ? Number(t[s + 1]) : n;
  }
  let i = t.includes("no-style"), r = !t.includes("noflip"), a = t.includes("fixed") ? "fixed" : "absolute";
  return {
    placement: e,
    offsetValue: n,
    unstyled: i,
    strategy: a,
    allowFlip: r
  };
}
var ar = rr;
function sr(t) {
  t.directive("collapse", e), e.inline = (n, { modifiers: i }) => {
    i.includes("min") && (n._x_doShow = () => {
    }, n._x_doHide = () => {
    });
  };
  function e(n, { modifiers: i }) {
    let r = ye(i, "duration", 250) / 1e3, a = ye(i, "min", 0), s = !i.includes("min");
    n._x_isShown || (n.style.height = `${a}px`), !n._x_isShown && s && (n.hidden = !0), n._x_isShown || (n.style.overflow = "hidden");
    let o = (c, u) => {
      let d = t.setStyles(c, u);
      return u.height ? () => {
      } : d;
    }, l = {
      transitionProperty: "height",
      transitionDuration: `${r}s`,
      transitionTimingFunction: "cubic-bezier(0.4, 0.0, 0.2, 1)"
    };
    n._x_transition = {
      in(c = () => {
      }, u = () => {
      }) {
        s && (n.hidden = !1), s && (n.style.display = null);
        let d = n.getBoundingClientRect().height;
        n.style.height = "auto";
        let m = n.getBoundingClientRect().height;
        d === m && (d = a), t.transition(n, t.setStyles, {
          during: l,
          start: { height: d + "px" },
          end: { height: m + "px" }
        }, () => n._x_isShown = !0, () => {
          Math.abs(n.getBoundingClientRect().height - m) < 1 && (n.style.overflow = null);
        });
      },
      out(c = () => {
      }, u = () => {
      }) {
        let d = n.getBoundingClientRect().height;
        t.transition(n, o, {
          during: l,
          start: { height: d + "px" },
          end: { height: a + "px" }
        }, () => n.style.overflow = "hidden", () => {
          n._x_isShown = !1, n.style.height == `${a}px` && s && (n.style.display = "none", n.hidden = !0);
        });
      }
    };
  }
}
function ye(t, e, n) {
  if (t.indexOf(e) === -1) return n;
  const i = t[t.indexOf(e) + 1];
  if (!i) return n;
  if (e === "duration") {
    let r = i.match(/([0-9]+)ms/);
    if (r) return r[1];
  }
  if (e === "min") {
    let r = i.match(/([0-9]+)px/);
    if (r) return r[1];
  }
  return i;
}
var or = sr, an = [
  "input:not([inert]):not([inert] *)",
  "select:not([inert]):not([inert] *)",
  "textarea:not([inert]):not([inert] *)",
  "a[href]:not([inert]):not([inert] *)",
  "button:not([inert]):not([inert] *)",
  "[tabindex]:not(slot):not([inert]):not([inert] *)",
  "audio[controls]:not([inert]):not([inert] *)",
  "video[controls]:not([inert]):not([inert] *)",
  '[contenteditable]:not([contenteditable="false"]):not([inert]):not([inert] *)',
  "details>summary:first-of-type:not([inert]):not([inert] *)",
  "details:not([inert]):not([inert] *)"
], Ft = /* @__PURE__ */ an.join(","), sn = typeof Element > "u", st = sn ? function() {
} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector, $t = !sn && Element.prototype.getRootNode ? function(t) {
  var e;
  return t == null || (e = t.getRootNode) === null || e === void 0 ? void 0 : e.call(t);
} : function(t) {
  return t?.ownerDocument;
}, Rt = function(e, n) {
  var i;
  n === void 0 && (n = !0);
  var r = e == null || (i = e.getAttribute) === null || i === void 0 ? void 0 : i.call(e, "inert");
  return r === "" || r === "true" || n && e && (typeof e.closest == "function" ? e.closest("[inert]") : Rt(e.parentNode));
}, lr = function(e) {
  var n, i = e == null || (n = e.getAttribute) === null || n === void 0 ? void 0 : n.call(e, "contenteditable");
  return i === "" || i === "true";
}, on = function(e, n, i) {
  if (Rt(e)) return [];
  var r = Array.prototype.slice.apply(e.querySelectorAll(Ft));
  return n && st.call(e, Ft) && r.unshift(e), r = r.filter(i), r;
}, Dt = function(e, n, i) {
  for (var r = [], a = Array.from(e); a.length; ) {
    var s = a.shift();
    if (!Rt(s, !1))
      if (s.tagName === "SLOT") {
        var o = s.assignedElements(), l = Dt(o.length ? o : s.children, !0, i);
        i.flatten ? r.push.apply(r, l) : r.push({
          scopeParent: s,
          candidates: l
        });
      } else {
        st.call(s, Ft) && i.filter(s) && (n || !e.includes(s)) && r.push(s);
        var c = s.shadowRoot || typeof i.getShadowRoot == "function" && i.getShadowRoot(s), u = !Rt(c, !1) && (!i.shadowRootFilter || i.shadowRootFilter(s));
        if (c && u) {
          var d = Dt(c === !0 ? s.children : c.children, !0, i);
          i.flatten ? r.push.apply(r, d) : r.push({
            scopeParent: s,
            candidates: d
          });
        } else a.unshift.apply(a, s.children);
      }
  }
  return r;
}, ln = function(e) {
  return !isNaN(parseInt(e.getAttribute("tabindex"), 10));
}, nt = function(e) {
  if (!e) throw new Error("No node provided");
  return e.tabIndex < 0 && (/^(AUDIO|VIDEO|DETAILS)$/.test(e.tagName) || lr(e)) && !ln(e) ? 0 : e.tabIndex;
}, cr = function(e, n) {
  var i = nt(e);
  return i < 0 && n && !ln(e) ? 0 : i;
}, ur = function(e, n) {
  return e.tabIndex === n.tabIndex ? e.documentOrder - n.documentOrder : e.tabIndex - n.tabIndex;
}, cn = function(e) {
  return e.tagName === "INPUT";
}, dr = function(e) {
  return cn(e) && e.type === "hidden";
}, fr = function(e) {
  return e.tagName === "DETAILS" && Array.prototype.slice.apply(e.children).some(function(n) {
    return n.tagName === "SUMMARY";
  });
}, hr = function(e, n) {
  for (var i = 0; i < e.length; i++) if (e[i].checked && e[i].form === n) return e[i];
}, mr = function(e) {
  if (!e.name) return !0;
  var n = e.form || $t(e), i = function(o) {
    return n.querySelectorAll('input[type="radio"][name="' + o + '"]');
  }, r;
  if (typeof window < "u" && typeof window.CSS < "u" && typeof window.CSS.escape == "function") r = i(window.CSS.escape(e.name));
  else try {
    r = i(e.name);
  } catch (s) {
    return console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", s.message), !1;
  }
  var a = hr(r, e.form);
  return !a || a === e;
}, vr = function(e) {
  return cn(e) && e.type === "radio";
}, pr = function(e) {
  return vr(e) && !mr(e);
}, gr = function(e) {
  var n, i = e && $t(e), r = (n = i) === null || n === void 0 ? void 0 : n.host, a = !1;
  if (i && i !== e) {
    var s, o, l;
    for (a = !!((s = r) !== null && s !== void 0 && (o = s.ownerDocument) !== null && o !== void 0 && o.contains(r) || e != null && (l = e.ownerDocument) !== null && l !== void 0 && l.contains(e)); !a && r; ) {
      var c, u, d;
      i = $t(r), r = (c = i) === null || c === void 0 ? void 0 : c.host, a = !!((u = r) !== null && u !== void 0 && (d = u.ownerDocument) !== null && d !== void 0 && d.contains(r));
    }
  }
  return a;
}, we = function(e) {
  var n = e.getBoundingClientRect(), i = n.width, r = n.height;
  return i === 0 && r === 0;
}, br = function(e, n) {
  var i = n.displayCheck, r = n.getShadowRoot;
  if (i === "full-native" && "checkVisibility" in e)
    return !e.checkVisibility({
      checkOpacity: !1,
      opacityProperty: !1,
      contentVisibilityAuto: !0,
      visibilityProperty: !0,
      checkVisibilityCSS: !0
    });
  if (getComputedStyle(e).visibility === "hidden") return !0;
  var a = st.call(e, "details>summary:first-of-type") ? e.parentElement : e;
  if (st.call(a, "details:not([open]) *")) return !0;
  if (!i || i === "full" || i === "full-native" || i === "legacy-full") {
    if (typeof r == "function") {
      for (var s = e; e; ) {
        var o = e.parentElement, l = $t(e);
        if (o && !o.shadowRoot && r(o) === !0) return we(e);
        e.assignedSlot ? e = e.assignedSlot : !o && l !== e.ownerDocument ? e = l.host : e = o;
      }
      e = s;
    }
    if (gr(e)) return !e.getClientRects().length;
    if (i !== "legacy-full") return !0;
  } else if (i === "non-zero-area") return we(e);
  return !1;
}, yr = function(e) {
  if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(e.tagName))
    for (var n = e.parentElement; n; ) {
      if (n.tagName === "FIELDSET" && n.disabled) {
        for (var i = 0; i < n.children.length; i++) {
          var r = n.children.item(i);
          if (r.tagName === "LEGEND") return st.call(n, "fieldset[disabled] *") ? !0 : !r.contains(e);
        }
        return !0;
      }
      n = n.parentElement;
    }
  return !1;
}, Mt = function(e, n) {
  return !(n.disabled || dr(n) || br(n, e) || fr(n) || yr(n));
}, Qt = function(e, n) {
  return !(pr(n) || nt(n) < 0 || !Mt(e, n));
}, wr = function(e) {
  var n = parseInt(e.getAttribute("tabindex"), 10);
  return !!(isNaN(n) || n >= 0);
}, un = function(e) {
  var n = [], i = [];
  return e.forEach(function(r, a) {
    var s = !!r.scopeParent, o = s ? r.scopeParent : r, l = cr(o, s), c = s ? un(r.candidates) : o;
    l === 0 ? s ? n.push.apply(n, c) : n.push(o) : i.push({
      documentOrder: a,
      tabIndex: l,
      item: r,
      isScope: s,
      content: c
    });
  }), i.sort(ur).reduce(function(r, a) {
    return a.isScope ? r.push.apply(r, a.content) : r.push(a.content), r;
  }, []).concat(n);
}, xr = function(e, n) {
  n = n || {};
  var i;
  return n.getShadowRoot ? i = Dt([e], n.includeContainer, {
    filter: Qt.bind(null, n),
    flatten: !1,
    getShadowRoot: n.getShadowRoot,
    shadowRootFilter: wr
  }) : i = on(e, n.includeContainer, Qt.bind(null, n)), un(i);
}, dn = function(e, n) {
  n = n || {};
  var i;
  return n.getShadowRoot ? i = Dt([e], n.includeContainer, {
    filter: Mt.bind(null, n),
    flatten: !0,
    getShadowRoot: n.getShadowRoot
  }) : i = on(e, n.includeContainer, Mt.bind(null, n)), i;
}, lt = function(e, n) {
  if (n = n || {}, !e) throw new Error("No node provided");
  return st.call(e, Ft) === !1 ? !1 : Qt(n, e);
}, Er = /* @__PURE__ */ an.concat("iframe:not([inert]):not([inert] *)").join(","), Ct = function(e, n) {
  if (n = n || {}, !e) throw new Error("No node provided");
  return st.call(e, Er) === !1 ? !1 : Mt(n, e);
};
function Zt(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var n = 0, i = Array(e); n < e; n++) i[n] = t[n];
  return i;
}
function Sr(t) {
  if (Array.isArray(t)) return Zt(t);
}
function xe(t, e, n, i, r, a, s) {
  try {
    var o = t[a](s), l = o.value;
  } catch (c) {
    n(c);
    return;
  }
  o.done ? e(l) : Promise.resolve(l).then(i, r);
}
function Ee(t) {
  return function() {
    var e = this, n = arguments;
    return new Promise(function(i, r) {
      var a = t.apply(e, n);
      function s(l) {
        xe(a, i, r, s, o, "next", l);
      }
      function o(l) {
        xe(a, i, r, s, o, "throw", l);
      }
      s(void 0);
    });
  };
}
function Se(t, e) {
  var n = typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (!n) {
    if (Array.isArray(t) || (n = fn(t)) || e) {
      n && (t = n);
      var i = 0, r = function() {
      };
      return {
        s: r,
        n: function() {
          return i >= t.length ? { done: !0 } : {
            done: !1,
            value: t[i++]
          };
        },
        e: function(l) {
          throw l;
        },
        f: r
      };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var a, s = !0, o = !1;
  return {
    s: function() {
      n = n.call(t);
    },
    n: function() {
      var l = n.next();
      return s = l.done, l;
    },
    e: function(l) {
      o = !0, a = l;
    },
    f: function() {
      try {
        s || n.return == null || n.return();
      } finally {
        if (o) throw a;
      }
    }
  };
}
function Tr(t, e, n) {
  return (e = Or(e)) in t ? Object.defineProperty(t, e, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[e] = n, t;
}
function kr(t) {
  if (typeof Symbol < "u" && t[Symbol.iterator] != null || t["@@iterator"] != null) return Array.from(t);
}
function Cr() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Te(t, e) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(t);
    e && (i = i.filter(function(r) {
      return Object.getOwnPropertyDescriptor(t, r).enumerable;
    })), n.push.apply(n, i);
  }
  return n;
}
function ke(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Te(Object(n), !0).forEach(function(i) {
      Tr(t, i, n[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : Te(Object(n)).forEach(function(i) {
      Object.defineProperty(t, i, Object.getOwnPropertyDescriptor(n, i));
    });
  }
  return t;
}
function vt() {
  var t, e, n = typeof Symbol == "function" ? Symbol : {}, i = n.iterator || "@@iterator", r = n.toStringTag || "@@toStringTag";
  function a(v, p, b, g) {
    var w = p && p.prototype instanceof o ? p : o, C = Object.create(w.prototype);
    return B(C, "_invoke", (function(O, _, A) {
      var R, k, F, z = 0, U = A || [], M = !1, S = {
        p: 0,
        n: 0,
        v: t,
        a: f,
        f: f.bind(t, 4),
        d: function(h, y) {
          return R = h, k = 0, F = t, S.n = y, s;
        }
      };
      function f(h, y) {
        for (k = h, F = y, e = 0; !M && z && !E && e < U.length; e++) {
          var E, x = U[e], N = S.p, T = x[2];
          h > 3 ? (E = T === y) && (F = x[(k = x[4]) ? 5 : (k = 3, 3)], x[4] = x[5] = t) : x[0] <= N && ((E = h < 2 && N < x[1]) ? (k = 0, S.v = y, S.n = x[1]) : N < T && (E = h < 3 || x[0] > y || y > T) && (x[4] = h, x[5] = y, S.n = T, k = 0));
        }
        if (E || h > 1) return s;
        throw M = !0, y;
      }
      return function(h, y, E) {
        if (z > 1) throw TypeError("Generator is already running");
        for (M && y === 1 && f(y, E), k = y, F = E; (e = k < 2 ? t : F) || !M; ) {
          R || (k ? k < 3 ? (k > 1 && (S.n = -1), f(k, F)) : S.n = F : S.v = F);
          try {
            if (z = 2, R) {
              if (k || (h = "next"), e = R[h]) {
                if (!(e = e.call(R, F))) throw TypeError("iterator result is not an object");
                if (!e.done) return e;
                F = e.value, k < 2 && (k = 0);
              } else k === 1 && (e = R.return) && e.call(R), k < 2 && (F = TypeError("The iterator does not provide a '" + h + "' method"), k = 1);
              R = t;
            } else if ((e = (M = S.n < 0) ? F : O.call(_, S)) !== s) break;
          } catch (x) {
            R = t, k = 1, F = x;
          } finally {
            z = 1;
          }
        }
        return {
          value: e,
          done: M
        };
      };
    })(v, b, g), !0), C;
  }
  var s = {};
  function o() {
  }
  function l() {
  }
  function c() {
  }
  e = Object.getPrototypeOf;
  var u = [][i] ? e(e([][i]())) : (B(e = {}, i, function() {
    return this;
  }), e), d = c.prototype = o.prototype = Object.create(u);
  function m(v) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(v, c) : (v.__proto__ = c, B(v, r, "GeneratorFunction")), v.prototype = Object.create(d), v;
  }
  return l.prototype = c, B(d, "constructor", c), B(c, "constructor", l), l.displayName = "GeneratorFunction", B(c, r, "GeneratorFunction"), B(d), B(d, r, "Generator"), B(d, i, function() {
    return this;
  }), B(d, "toString", function() {
    return "[object Generator]";
  }), (vt = function() {
    return {
      w: a,
      m
    };
  })();
}
function B(t, e, n, i) {
  var r = Object.defineProperty;
  try {
    r({}, "", {});
  } catch {
    r = 0;
  }
  B = function(a, s, o, l) {
    function c(u, d) {
      B(a, u, function(m) {
        return this._invoke(u, d, m);
      });
    }
    s ? r ? r(a, s, {
      value: o,
      enumerable: !l,
      configurable: !l,
      writable: !l
    }) : a[s] = o : (c("next", 0), c("throw", 1), c("return", 2));
  }, B(t, e, n, i);
}
function Ir(t) {
  return Sr(t) || kr(t) || fn(t) || Cr();
}
function Nr(t, e) {
  if (typeof t != "object" || !t) return t;
  var n = t[Symbol.toPrimitive];
  if (n !== void 0) {
    var i = n.call(t, e);
    if (typeof i != "object") return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
function Or(t) {
  var e = Nr(t, "string");
  return typeof e == "symbol" ? e : e + "";
}
function fn(t, e) {
  if (t) {
    if (typeof t == "string") return Zt(t, e);
    var n = {}.toString.call(t).slice(8, -1);
    return n === "Object" && t.constructor && (n = t.constructor.name), n === "Map" || n === "Set" ? Array.from(t) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? Zt(t, e) : void 0;
  }
}
var G = {
  getActiveTrap: function(e) {
    return e?.length > 0 ? e[e.length - 1] : null;
  },
  activateTrap: function(e, n) {
    n !== G.getActiveTrap(e) && G.pauseTrap(e);
    var i = e.indexOf(n);
    i === -1 || e.splice(i, 1), e.push(n);
  },
  deactivateTrap: function(e, n) {
    var i = e.indexOf(n);
    i !== -1 && e.splice(i, 1), G.unpauseTrap(e);
  },
  pauseTrap: function(e) {
    var n = G.getActiveTrap(e);
    n?._setPausedState(!0);
  },
  unpauseTrap: function(e) {
    var n = G.getActiveTrap(e);
    n && !n._isManuallyPaused() && n._setPausedState(!1);
  }
}, Lr = function(e) {
  return e.tagName && e.tagName.toLowerCase() === "input" && typeof e.select == "function";
}, Ar = function(e) {
  return e?.key === "Escape" || e?.key === "Esc" || e?.keyCode === 27;
}, pt = function(e) {
  return e?.key === "Tab" || e?.keyCode === 9;
}, _r = function(e) {
  return pt(e) && !e.shiftKey;
}, Fr = function(e) {
  return pt(e) && e.shiftKey;
}, Ce = function(e) {
  return setTimeout(e, 0);
}, ft = function(e) {
  for (var n = arguments.length, i = new Array(n > 1 ? n - 1 : 0), r = 1; r < n; r++) i[r - 1] = arguments[r];
  return typeof e == "function" ? e.apply(void 0, i) : e;
}, Tt = function(e) {
  return e.target.shadowRoot && typeof e.composedPath == "function" ? e.composedPath()[0] : e.target;
}, $r = [], Rr = function(e, n) {
  var i = n?.document || document, r = n?.trapStack || $r, a = ke({
    returnFocusOnDeactivate: !0,
    escapeDeactivates: !0,
    delayInitialFocus: !0,
    isolateSubtrees: !1,
    isKeyForward: _r,
    isKeyBackward: Fr
  }, n), s = {
    containers: [],
    containerGroups: [],
    tabbableGroups: [],
    adjacentElements: /* @__PURE__ */ new Set(),
    alreadySilent: /* @__PURE__ */ new Set(),
    nodeFocusedBeforeActivation: null,
    mostRecentlyFocusedNode: null,
    active: !1,
    paused: !1,
    manuallyPaused: !1,
    delayInitialFocusTimer: void 0,
    recentNavEvent: void 0
  }, o, l = function(f, h, y) {
    return f && f[h] !== void 0 ? f[h] : a[y || h];
  }, c = function(f, h) {
    var y = typeof h?.composedPath == "function" ? h.composedPath() : void 0;
    return s.containerGroups.findIndex(function(E) {
      var x = E.container, N = E.tabbableNodes;
      return x.contains(f) || y?.includes(x) || N.find(function(T) {
        return T === f;
      });
    });
  }, u = function(f) {
    var h = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, y = h.hasFallback, E = y === void 0 ? !1 : y, x = h.params, N = x === void 0 ? [] : x, T = a[f];
    if (typeof T == "function" && (T = T.apply(void 0, Ir(N))), T === !0 && (T = void 0), !T) {
      if (T === void 0 || T === !1) return T;
      throw new Error("`".concat(f, "` was specified but was not a node, or did not return a node"));
    }
    var I = T;
    if (typeof T == "string") {
      try {
        I = i.querySelector(T);
      } catch (L) {
        throw new Error("`".concat(f, '` appears to be an invalid selector; error="').concat(L.message, '"'));
      }
      if (!I && !E)
        throw new Error("`".concat(f, "` as selector refers to no known node"));
    }
    return I;
  }, d = function() {
    var f = u("initialFocus", { hasFallback: !0 });
    if (f === !1) return !1;
    if (f === void 0 || f && !Ct(f, a.tabbableOptions))
      if (c(i.activeElement) >= 0) f = i.activeElement;
      else {
        var h = s.tabbableGroups[0];
        f = h && h.firstTabbableNode || u("fallbackFocus");
      }
    else f === null && (f = u("fallbackFocus"));
    if (!f) throw new Error("Your focus-trap needs to have at least one focusable element");
    return f;
  }, m = function() {
    if (s.containerGroups = s.containers.map(function(f) {
      var h = xr(f, a.tabbableOptions), y = dn(f, a.tabbableOptions), E = h.length > 0 ? h[0] : void 0, x = h.length > 0 ? h[h.length - 1] : void 0, N = y.find(function(I) {
        return lt(I);
      }), T = y.slice().reverse().find(function(I) {
        return lt(I);
      });
      return {
        container: f,
        tabbableNodes: h,
        focusableNodes: y,
        posTabIndexesFound: !!h.find(function(I) {
          return nt(I) > 0;
        }),
        firstTabbableNode: E,
        lastTabbableNode: x,
        firstDomTabbableNode: N,
        lastDomTabbableNode: T,
        nextTabbableNode: function(L) {
          var q = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0, j = h.indexOf(L);
          return j < 0 ? q ? y.slice(y.indexOf(L) + 1).find(function(D) {
            return lt(D);
          }) : y.slice(0, y.indexOf(L)).reverse().find(function(D) {
            return lt(D);
          }) : h[j + (q ? 1 : -1)];
        }
      };
    }), s.tabbableGroups = s.containerGroups.filter(function(f) {
      return f.tabbableNodes.length > 0;
    }), s.tabbableGroups.length <= 0 && !u("fallbackFocus")) throw new Error("Your focus-trap must have at least one container with at least one tabbable node in it at all times");
    if (s.containerGroups.find(function(f) {
      return f.posTabIndexesFound;
    }) && s.containerGroups.length > 1) throw new Error("At least one node with a positive tabindex was found in one of your focus-trap's multiple containers. Positive tabindexes are only supported in single-container focus-traps.");
  }, v = function(f) {
    var h = f.activeElement;
    if (h)
      return h.shadowRoot && h.shadowRoot.activeElement !== null ? v(h.shadowRoot) : h;
  }, p = function(f) {
    if (f !== !1 && f !== v(document)) {
      if (!f || !f.focus) {
        p(d());
        return;
      }
      f.focus({ preventScroll: !!a.preventScroll }), s.mostRecentlyFocusedNode = f, Lr(f) && f.select();
    }
  }, b = function(f) {
    var h = u("setReturnFocus", { params: [f] });
    return h || (h === !1 ? !1 : f);
  }, g = function(f) {
    var h = f.target, y = f.event, E = f.isBackward, x = E === void 0 ? !1 : E;
    h = h || Tt(y), m();
    var N = null;
    if (s.tabbableGroups.length > 0) {
      var T = c(h, y), I = T >= 0 ? s.containerGroups[T] : void 0;
      if (T < 0)
        x ? N = s.tabbableGroups[s.tabbableGroups.length - 1].lastTabbableNode : N = s.tabbableGroups[0].firstTabbableNode;
      else if (x) {
        var L = s.tabbableGroups.findIndex(function(Kt) {
          var Wt = Kt.firstTabbableNode;
          return h === Wt;
        });
        if (L < 0 && (I.container === h || Ct(h, a.tabbableOptions) && !lt(h, a.tabbableOptions) && !I.nextTabbableNode(h, !1)) && (L = T), L >= 0) {
          var q = L === 0 ? s.tabbableGroups.length - 1 : L - 1, j = s.tabbableGroups[q];
          N = nt(h) >= 0 ? j.lastTabbableNode : j.lastDomTabbableNode;
        } else pt(y) || (N = I.nextTabbableNode(h, !1));
      } else {
        var D = s.tabbableGroups.findIndex(function(Kt) {
          var Wt = Kt.lastTabbableNode;
          return h === Wt;
        });
        if (D < 0 && (I.container === h || Ct(h, a.tabbableOptions) && !lt(h, a.tabbableOptions) && !I.nextTabbableNode(h)) && (D = T), D >= 0) {
          var zt = D === s.tabbableGroups.length - 1 ? 0 : D + 1, X = s.tabbableGroups[zt];
          N = nt(h) >= 0 ? X.firstTabbableNode : X.firstDomTabbableNode;
        } else pt(y) || (N = I.nextTabbableNode(h));
      }
    } else N = u("fallbackFocus");
    return N;
  }, w = function(f) {
    if (!(c(Tt(f), f) >= 0)) {
      if (ft(a.clickOutsideDeactivates, f)) {
        o.deactivate({ returnFocus: a.returnFocusOnDeactivate });
        return;
      }
      ft(a.allowOutsideClick, f) || f.preventDefault();
    }
  }, C = function(f) {
    var h = Tt(f), y = c(h, f) >= 0;
    if (y || h instanceof Document)
      y && (s.mostRecentlyFocusedNode = h);
    else {
      f.stopImmediatePropagation();
      var E, x = !0;
      if (s.mostRecentlyFocusedNode)
        if (nt(s.mostRecentlyFocusedNode) > 0) {
          var N = c(s.mostRecentlyFocusedNode), T = s.containerGroups[N].tabbableNodes;
          if (T.length > 0) {
            var I = T.findIndex(function(L) {
              return L === s.mostRecentlyFocusedNode;
            });
            I >= 0 && (a.isKeyForward(s.recentNavEvent) ? I + 1 < T.length && (E = T[I + 1], x = !1) : I - 1 >= 0 && (E = T[I - 1], x = !1));
          }
        } else s.containerGroups.some(function(L) {
          return L.tabbableNodes.some(function(q) {
            return nt(q) > 0;
          });
        }) || (x = !1);
      else x = !1;
      x && (E = g({
        target: s.mostRecentlyFocusedNode,
        isBackward: a.isKeyBackward(s.recentNavEvent)
      })), p(E || s.mostRecentlyFocusedNode || d());
    }
    s.recentNavEvent = void 0;
  }, O = function(f) {
    var h = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    s.recentNavEvent = f;
    var y = g({
      event: f,
      isBackward: h
    });
    y && (pt(f) && f.preventDefault(), p(y));
  }, _ = function(f) {
    (a.isKeyForward(f) || a.isKeyBackward(f)) && O(f, a.isKeyBackward(f));
  }, A = function(f) {
    Ar(f) && ft(a.escapeDeactivates, f) !== !1 && (f.preventDefault(), o.deactivate());
  }, R = function(f) {
    c(Tt(f), f) >= 0 || ft(a.clickOutsideDeactivates, f) || ft(a.allowOutsideClick, f) || (f.preventDefault(), f.stopImmediatePropagation());
  }, k = function() {
    if (!s.active) return Promise.resolve();
    G.activateTrap(r, o);
    var f;
    return a.delayInitialFocus ? f = new Promise(function(h) {
      s.delayInitialFocusTimer = Ce(function() {
        p(d()), h();
      });
    }) : (f = Promise.resolve(), p(d())), i.addEventListener("focusin", C, !0), i.addEventListener("mousedown", w, {
      capture: !0,
      passive: !1
    }), i.addEventListener("touchstart", w, {
      capture: !0,
      passive: !1
    }), i.addEventListener("click", R, {
      capture: !0,
      passive: !1
    }), i.addEventListener("keydown", _, {
      capture: !0,
      passive: !1
    }), i.addEventListener("keydown", A), f;
  }, F = function(f) {
    s.active && !s.paused && o._setSubtreeIsolation(!1), s.adjacentElements.clear(), s.alreadySilent.clear();
    var h = /* @__PURE__ */ new Set(), y = /* @__PURE__ */ new Set(), E = Se(f), x;
    try {
      for (E.s(); !(x = E.n()).done; ) {
        var N = x.value;
        h.add(N);
        for (var T = typeof ShadowRoot < "u" && N.getRootNode() instanceof ShadowRoot, I = N; I; ) {
          h.add(I);
          var L = I.parentElement, q = [];
          L ? q = L.children : !L && T && (q = I.getRootNode().children, L = I.getRootNode().host, T = typeof ShadowRoot < "u" && L.getRootNode() instanceof ShadowRoot);
          var j = Se(q), D;
          try {
            for (j.s(); !(D = j.n()).done; ) {
              var zt = D.value;
              y.add(zt);
            }
          } catch (X) {
            j.e(X);
          } finally {
            j.f();
          }
          I = L;
        }
      }
    } catch (X) {
      E.e(X);
    } finally {
      E.f();
    }
    h.forEach(function(X) {
      y.delete(X);
    }), s.adjacentElements = y;
  }, z = function() {
    if (s.active)
      return i.removeEventListener("focusin", C, !0), i.removeEventListener("mousedown", w, !0), i.removeEventListener("touchstart", w, !0), i.removeEventListener("click", R, !0), i.removeEventListener("keydown", _, !0), i.removeEventListener("keydown", A), o;
  }, U = typeof window < "u" && "MutationObserver" in window ? new MutationObserver(function(f) {
    f.some(function(h) {
      return Array.from(h.removedNodes).some(function(y) {
        return y === s.mostRecentlyFocusedNode;
      });
    }) && p(d());
  }) : void 0, M = function() {
    U && (U.disconnect(), s.active && !s.paused && s.containers.map(function(f) {
      U.observe(f, {
        subtree: !0,
        childList: !0
      });
    }));
  };
  return o = {
    get active() {
      return s.active;
    },
    get paused() {
      return s.paused;
    },
    activate: function(f) {
      if (s.active) return this;
      var h = l(f, "onActivate"), y = l(f, "onPostActivate"), E = l(f, "checkCanFocusTrap"), x = G.getActiveTrap(r), N = !1;
      if (x && !x.paused) {
        var T;
        (T = x._setSubtreeIsolation) === null || T === void 0 || T.call(x, !1), N = !0;
      }
      try {
        E || m(), s.active = !0, s.paused = !1, s.nodeFocusedBeforeActivation = v(i), h?.();
        var I = /* @__PURE__ */ (function() {
          var q = Ee(/* @__PURE__ */ vt().m(function j() {
            return vt().w(function(D) {
              for (; ; ) switch (D.n) {
                case 0:
                  return E && m(), D.n = 1, k();
                case 1:
                  o._setSubtreeIsolation(!0), M(), y?.();
                case 2:
                  return D.a(2);
              }
            }, j);
          }));
          return function() {
            return q.apply(this, arguments);
          };
        })();
        if (E)
          return E(s.containers.concat()).then(I, I), this;
        I();
      } catch (q) {
        if (x === G.getActiveTrap(r) && N) {
          var L;
          (L = x._setSubtreeIsolation) === null || L === void 0 || L.call(x, !0);
        }
        throw q;
      }
      return this;
    },
    deactivate: function(f) {
      if (!s.active) return this;
      var h = ke({
        onDeactivate: a.onDeactivate,
        onPostDeactivate: a.onPostDeactivate,
        checkCanReturnFocus: a.checkCanReturnFocus
      }, f);
      clearTimeout(s.delayInitialFocusTimer), s.delayInitialFocusTimer = void 0, s.paused || o._setSubtreeIsolation(!1), s.alreadySilent.clear(), z(), s.active = !1, s.paused = !1, M(), G.deactivateTrap(r, o);
      var y = l(h, "onDeactivate"), E = l(h, "onPostDeactivate"), x = l(h, "checkCanReturnFocus"), N = l(h, "returnFocus", "returnFocusOnDeactivate");
      y?.();
      var T = function() {
        Ce(function() {
          N && p(b(s.nodeFocusedBeforeActivation)), E?.();
        });
      };
      return N && x ? (x(b(s.nodeFocusedBeforeActivation)).then(T, T), this) : (T(), this);
    },
    pause: function(f) {
      return s.active ? (s.manuallyPaused = !0, this._setPausedState(!0, f)) : this;
    },
    unpause: function(f) {
      return s.active ? (s.manuallyPaused = !1, r[r.length - 1] !== this ? this : this._setPausedState(!1, f)) : this;
    },
    updateContainerElements: function(f) {
      return s.containers = [].concat(f).filter(Boolean).map(function(h) {
        return typeof h == "string" ? i.querySelector(h) : h;
      }), a.isolateSubtrees && F(s.containers), s.active && (m(), s.paused || o._setSubtreeIsolation(!0)), M(), this;
    }
  }, Object.defineProperties(o, {
    _isManuallyPaused: { value: function() {
      return s.manuallyPaused;
    } },
    _setPausedState: { value: function(f, h) {
      if (s.paused === f) return this;
      if (s.paused = f, f) {
        var y = l(h, "onPause"), E = l(h, "onPostPause");
        y?.(), z(), o._setSubtreeIsolation(!1), M(), E?.();
      } else {
        var x = l(h, "onUnpause"), N = l(h, "onPostUnpause");
        x?.(), (/* @__PURE__ */ (function() {
          var T = Ee(/* @__PURE__ */ vt().m(function I() {
            return vt().w(function(L) {
              for (; ; ) switch (L.n) {
                case 0:
                  return m(), L.n = 1, k();
                case 1:
                  o._setSubtreeIsolation(!0), M(), N?.();
                case 2:
                  return L.a(2);
              }
            }, I);
          }));
          return function() {
            return T.apply(this, arguments);
          };
        })())();
      }
      return this;
    } },
    _setSubtreeIsolation: { value: function(f) {
      a.isolateSubtrees && s.adjacentElements.forEach(function(h) {
        var y;
        f ? a.isolateSubtrees === "aria-hidden" ? ((h.ariaHidden === "true" || ((y = h.getAttribute("aria-hidden")) === null || y === void 0 ? void 0 : y.toLowerCase()) === "true") && s.alreadySilent.add(h), h.setAttribute("aria-hidden", "true")) : ((h.inert || h.hasAttribute("inert")) && s.alreadySilent.add(h), h.setAttribute("inert", !0)) : s.alreadySilent.has(h) || (a.isolateSubtrees === "aria-hidden" ? h.removeAttribute("aria-hidden") : h.removeAttribute("inert"));
      });
    } }
  }), o.updateContainerElements(e), o;
};
function Dr(t) {
  let e, n;
  window.addEventListener("focusin", () => {
    e = n, n = document.activeElement;
  }), t.magic("focus", (i) => {
    let r = i;
    return {
      __noscroll: !1,
      __wrapAround: !1,
      within(a) {
        return r = a, this;
      },
      withoutScrolling() {
        return this.__noscroll = !0, this;
      },
      noscroll() {
        return this.__noscroll = !0, this;
      },
      withWrapAround() {
        return this.__wrapAround = !0, this;
      },
      wrap() {
        return this.withWrapAround();
      },
      focusable(a) {
        return Ct(a);
      },
      previouslyFocused() {
        return e;
      },
      lastFocused() {
        return e;
      },
      focused() {
        return n;
      },
      focusables() {
        return Array.isArray(r) ? r : dn(r, { displayCheck: "none" });
      },
      all() {
        return this.focusables();
      },
      isFirst(a) {
        let s = this.all();
        return s[0] && s[0].isSameNode(a);
      },
      isLast(a) {
        let s = this.all();
        return s.length && s.slice(-1)[0].isSameNode(a);
      },
      getFirst() {
        return this.all()[0];
      },
      getLast() {
        return this.all().slice(-1)[0];
      },
      getNext() {
        let a = this.all(), s = document.activeElement;
        if (a.indexOf(s) !== -1)
          return this.__wrapAround && a.indexOf(s) === a.length - 1 ? a[0] : a[a.indexOf(s) + 1];
      },
      getPrevious() {
        let a = this.all(), s = document.activeElement;
        if (a.indexOf(s) !== -1)
          return this.__wrapAround && a.indexOf(s) === 0 ? a.slice(-1)[0] : a[a.indexOf(s) - 1];
      },
      first() {
        this.focus(this.getFirst());
      },
      last() {
        this.focus(this.getLast());
      },
      next() {
        this.focus(this.getNext());
      },
      previous() {
        this.focus(this.getPrevious());
      },
      prev() {
        return this.previous();
      },
      focus(a) {
        a && setTimeout(() => {
          a.hasAttribute("tabindex") || a.setAttribute("tabindex", "0"), a.focus({ preventScroll: this.__noscroll });
        });
      }
    };
  }), t.directive("trap", t.skipDuringClone((i, { expression: r, modifiers: a }, { effect: s, evaluateLater: o, cleanup: l }) => {
    let c = o(r), u = !1, d = {
      escapeDeactivates: !1,
      allowOutsideClick: !0,
      fallbackFocus: () => i
    }, m = () => {
    };
    if (a.includes("noautofocus")) d.initialFocus = !1;
    else {
      let g = i.querySelector("[autofocus]");
      g && (d.initialFocus = g);
    }
    a.includes("inert") && (d.onPostActivate = () => {
      t.nextTick(() => {
        m = Ie(i);
      });
    });
    let v = Rr(i, d), p = () => {
    };
    const b = () => {
      m(), m = () => {
      }, p(), p = () => {
      }, v.deactivate({ returnFocus: !a.includes("noreturn") });
    };
    s(() => c((g) => {
      u !== g && (g && !u && (a.includes("noscroll") && (p = Mr()), setTimeout(() => {
        v.activate();
      }, 15)), !g && u && b(), u = !!g);
    })), l(b);
  }, (i, { expression: r, modifiers: a }, { evaluate: s }) => {
    a.includes("inert") && s(r) && Ie(i);
  }));
}
function Ie(t) {
  let e = [];
  return hn(t, (n) => {
    let i = n.hasAttribute("aria-hidden");
    n.setAttribute("aria-hidden", "true"), e.push(() => i || n.removeAttribute("aria-hidden"));
  }), () => {
    for (; e.length; ) e.pop()();
  };
}
function hn(t, e) {
  t.isSameNode(document.body) || !t.parentNode || Array.from(t.parentNode.children).forEach((n) => {
    n.isSameNode(t) ? hn(t.parentNode, e) : e(n);
  });
}
function Mr() {
  let t = document.documentElement.style.overflow, e = document.documentElement.style.paddingRight, n = window.innerWidth - document.documentElement.clientWidth, i = window.getComputedStyle(document.documentElement).scrollbarGutter;
  return document.documentElement.style.overflow = "hidden", i && i !== "auto" ? () => {
    document.documentElement.style.overflow = t;
  } : (document.documentElement.style.paddingRight = `${n}px`, () => {
    document.documentElement.style.overflow = t, document.documentElement.style.paddingRight = e;
  });
}
var Pr = Dr;
function qr(t) {
  t.directive("intersect", t.skipDuringClone((e, { value: n, expression: i, modifiers: r }, { evaluateLater: a, cleanup: s }) => {
    let o = a(i), l = Hr(r), c = {
      rootMargin: zr(r),
      threshold: l,
      root: r.includes("parent") ? e.parentElement : null
    };
    if (r.includes("dwell")) {
      jr(e, n, r, o, s, c, l);
      return;
    }
    let u = new IntersectionObserver((d) => {
      d.forEach((m) => {
        m.isIntersecting !== (n === "leave") && (o(), r.includes("once") && u.disconnect());
      });
    }, c);
    u.observe(e), s(() => {
      u.disconnect();
    });
  }));
}
function jr(t, e, n, i, r, a, s) {
  let o, l, c = !1, u = !1, d = Br(n), m, v = () => {
    clearTimeout(o), o = void 0;
  }, p = () => {
    u = !1, !(!l || document.hidden || !kt(l, e, s)) && (c = !0, i(), n.includes("once") && (m.disconnect(), document.removeEventListener("visibilitychange", O)));
  }, b = () => {
    m && m.disconnect(), m = new IntersectionObserver(C, a), m.observe(t);
  }, g = () => {
    if (o = void 0, document.hidden) return;
    let _ = m.takeRecords();
    if (_.some((A) => !kt(A, e, s))) {
      C(_);
      return;
    }
    u = !0, l = void 0, b();
  }, w = () => {
    o !== void 0 || c || document.hidden || !l || kt(l, e, s) && (o = setTimeout(g, d));
  }, C = (_) => {
    _.forEach((A) => {
      if (l = A, !kt(A, e, s)) {
        v(), c = !1, u = !1;
        return;
      }
      if (u) {
        p();
        return;
      }
      w();
    });
  }, O = () => {
    if (document.hidden) {
      v(), l = void 0, c = !1, u = !1, m.disconnect();
      return;
    }
    b();
  };
  b(), document.addEventListener("visibilitychange", O), r(() => {
    v(), m.disconnect(), document.removeEventListener("visibilitychange", O);
  });
}
function kt(t, e, n) {
  let i = n === 0 ? t.isIntersecting : t.isIntersecting && t.intersectionRatio >= n;
  return e === "leave" ? !i : i;
}
function Br(t) {
  let e = (t[t.indexOf("dwell") + 1] || "").match(/^([0-9]+)(ms)?$/);
  return e ? Number(e[1]) : 250;
}
function Hr(t) {
  if (t.includes("full")) return 0.99;
  if (t.includes("half")) return 0.5;
  if (!t.includes("threshold")) return 0;
  let e = t[t.indexOf("threshold") + 1];
  return e === "100" ? 1 : e === "0" ? 0 : +`.${e}`;
}
function Vr(t) {
  let e = t.match(/^(-?[0-9]+)(px|%)?$/);
  return e ? e[1] + (e[2] || "px") : void 0;
}
function zr(t) {
  const e = "margin", n = "0px 0px 0px 0px", i = t.indexOf(e);
  if (i === -1) return n;
  let r = [];
  for (let a = 1; a < 5; a++) r.push(Vr(t[i + a] || ""));
  return r = r.filter((a) => a !== void 0), r.length ? r.join(" ").trim() : n;
}
var Kr = qr;
function se(t, e, n) {
  vn();
  let i = mn(n), r = typeof e == "string" ? Gr(e) : e;
  return window.Alpine && window.Alpine.closestDataStack && !t._x_dataStack && (r._x_dataStack = window.Alpine.closestDataStack(t), r._x_dataStack && window.Alpine.cloneNode(t, r)), i.patch(t, r), t;
}
function Wr(t, e, n, i = {}) {
  vn();
  let r = mn(i), a = t.parentNode, s = new bt(t, e), o = typeof n == "string" ? (() => {
    let d = document.createElement("div");
    return d.insertAdjacentHTML("beforeend", n), d;
  })() : n, l = document.createComment("[morph-start]"), c = document.createComment("[morph-end]");
  o.insertBefore(l, o.firstChild), o.appendChild(c);
  let u = new bt(l, c);
  window.Alpine && window.Alpine.closestDataStack && (o._x_dataStack = window.Alpine.closestDataStack(a), o._x_dataStack && window.Alpine.cloneNode(a, o)), r.patchChildren(s, u);
}
function mn(t = {}) {
  let e = (r) => r.getAttribute("key"), n = () => {
  }, i = {
    key: t.key || e,
    lookahead: t.lookahead || !1,
    updating: t.updating || n,
    updated: t.updated || n,
    removing: t.removing || n,
    removed: t.removed || n,
    adding: t.adding || n,
    added: t.added || n
  };
  return i.patch = function(r, a) {
    if (i.differentElementNamesTypesOrKeys(r, a)) return i.swapElements(r, a);
    let s = !1, o = !1, l = (c) => i.skipUntilCondition = c;
    if (!Ur(i.updating, () => o = !0, l, r, a, () => s = !0)) {
      if (r.nodeType === 1 && window.Alpine && (window.Alpine.cloneNode(r, a), r._x_teleport && a._x_teleport && i.patch(r._x_teleport, a._x_teleport)), Yr(a)) {
        i.patchNodeValue(r, a), i.updated(r, a);
        return;
      }
      s || i.patchAttributes(r, a), i.updated(r, a), o || i.patchChildren(r, a);
    }
  }, i.differentElementNamesTypesOrKeys = function(r, a) {
    return r.nodeType != a.nodeType || r.nodeName != a.nodeName || i.getKey(r) != i.getKey(a);
  }, i.swapElements = function(r, a) {
    if (ht(i.removing, r)) return;
    let s = a.cloneNode(!0);
    ht(i.adding, s) || (r.replaceWith(s), i.removed(r), i.added(s));
  }, i.patchNodeValue = function(r, a) {
    let s = a.nodeValue;
    r.nodeValue !== s && (r.nodeValue = s);
  }, i.patchAttributes = function(r, a) {
    if (r._x_transitioning || r._x_isShown && !a._x_isShown || !r._x_isShown && a._x_isShown) return;
    let s = Array.from(r.attributes), o = Array.from(a.attributes);
    for (let l = s.length - 1; l >= 0; l--) {
      let c = s[l].name;
      a.hasAttribute(c) || (c === "open" && r.nodeName === "DIALOG" && r.open ? r.close() : r.removeAttribute(c));
    }
    for (let l = o.length - 1; l >= 0; l--) {
      let c = o[l].name, u = o[l].value;
      r.getAttribute(c) !== u && r.setAttribute(c, u);
    }
  }, i.patchChildren = function(r, a) {
    let s = i.keyToMap(r.children), o = {}, l = Oe(a), c = Oe(r);
    for (; l; ) {
      Jr(l, c);
      let d = i.getKey(l), m = i.getKey(c);
      if (i.skipUntilCondition) {
        let g = !c || i.skipUntilCondition(c), w = !l || i.skipUntilCondition(l);
        if (g && w) i.skipUntilCondition = null;
        else {
          g || (c = c && P(r, c)), w || (l = l && P(a, l));
          continue;
        }
      }
      if (!c)
        if (d && o[d]) {
          let g = o[d];
          r.appendChild(g), c = g, m = i.getKey(c);
        } else {
          if (!ht(i.adding, l)) {
            let g = l.cloneNode(!0);
            r.appendChild(g), i.added(g);
          }
          l = P(a, l);
          continue;
        }
      let v = (g) => g && g.nodeType === 8 && g.textContent === "[if BLOCK]><![endif]", p = (g) => g && g.nodeType === 8 && g.textContent === "[if ENDBLOCK]><![endif]";
      if (v(l) && v(c)) {
        let g = 0, w = c;
        for (; c; ) {
          let k = P(r, c);
          if (v(k)) g++;
          else if (p(k) && g > 0) g--;
          else if (p(k) && g === 0) {
            c = k;
            break;
          }
          c = k;
        }
        let C = c;
        g = 0;
        let O = l;
        for (; l; ) {
          let k = P(a, l);
          if (v(k)) g++;
          else if (p(k) && g > 0) g--;
          else if (p(k) && g === 0) {
            l = k;
            break;
          }
          l = k;
        }
        let _ = l, A = new bt(w, C), R = new bt(O, _);
        i.patchChildren(A, R);
        continue;
      }
      if (c.nodeType === 1 && i.lookahead && !c.isEqualNode(l)) {
        let g = P(a, l), w = !1;
        for (; !w && g; )
          g.nodeType === 1 && c.isEqualNode(g) && (w = !0, c = i.addNodeBefore(r, l, c), m = i.getKey(c)), g = P(a, g);
      }
      if (d !== m) {
        if (!d && m) {
          o[m] = c, c = i.addNodeBefore(r, l, c), o[m].remove(), c = P(r, c), l = P(a, l);
          continue;
        }
        if (d && !m && s[d] && (c.replaceWith(s[d]), c = s[d], m = i.getKey(c)), d && m) {
          let g = s[d];
          if (g)
            o[m] = c, c.replaceWith(g), c = g, m = i.getKey(c);
          else {
            o[m] = c, c = i.addNodeBefore(r, l, c), o[m].remove(), c = P(r, c), l = P(a, l);
            continue;
          }
        }
      }
      let b = c && P(r, c);
      i.patch(c, l), c._x_lastRenderedEl && (b = P(r, c._x_lastRenderedEl)), l = l && P(a, l), c = b;
    }
    let u = [];
    for (; c; )
      ht(i.removing, c) || u.push(c), c = P(r, c);
    for (; u.length; ) {
      let d = u.shift();
      d.remove(), i.removed(d);
    }
  }, i.getKey = function(r) {
    return r && r.nodeType === 1 && i.key(r);
  }, i.keyToMap = function(r) {
    let a = {};
    for (let s of r) {
      let o = i.getKey(s);
      o && (a[o] = s);
    }
    return a;
  }, i.addNodeBefore = function(r, a, s) {
    if (!ht(i.adding, a)) {
      let o = a.cloneNode(!0);
      return r.insertBefore(o, s), i.added(o), o;
    }
    return a;
  }, i;
}
se.step = () => {
};
se.log = () => {
};
function ht(t, ...e) {
  let n = !1;
  return t(...e, () => n = !0), n;
}
function Ur(t, e, n, ...i) {
  let r = !1;
  return t(...i, () => r = !0, e, n), r;
}
var Ne = !1;
function Gr(t) {
  const e = document.createElement("template");
  return e.innerHTML = t, e.content.firstElementChild;
}
function Yr(t) {
  return t.nodeType === 3 || t.nodeType === 8;
}
var bt = class {
  constructor(t, e) {
    this.startComment = t, this.endComment = e;
  }
  get children() {
    let t = [], e = this.startComment.nextSibling;
    for (; e && e !== this.endComment; )
      t.push(e), e = e.nextSibling;
    return t;
  }
  appendChild(t) {
    this.endComment.before(t);
  }
  get firstChild() {
    let t = this.startComment.nextSibling;
    if (t !== this.endComment)
      return t;
  }
  nextNode(t) {
    let e = t.nextSibling;
    if (e !== this.endComment)
      return e;
  }
  insertBefore(t, e) {
    return e.before(t), t;
  }
};
function Oe(t) {
  return t.firstChild;
}
function P(t, e) {
  let n;
  return t instanceof bt ? n = t.nextNode(e) : n = e.nextSibling, n;
}
function vn() {
  if (Ne) return;
  Ne = !0;
  let t = Element.prototype.setAttribute, e = document.createElement("div");
  Element.prototype.setAttribute = function(i, r) {
    if (!i.includes("@")) return t.call(this, i, r);
    let a = r.replace(/&/g, "&amp;").replace(/"/g, "&quot;");
    e.innerHTML = `<span ${i}="${a}"></span>`;
    let s = e.firstElementChild.getAttributeNode(i);
    e.firstElementChild.removeAttributeNode(s), this.setAttributeNode(s);
  };
}
function Jr(t, e) {
  let n = e && e._x_bindings && e._x_bindings.id;
  n && t.setAttribute && (t.setAttribute("id", n), t.id = n);
}
function Xr(t) {
  t.morph = se, t.morphBetween = Wr;
}
var Qr = Xr, Zr = (t, e) => {
  let n;
  const i = /* @__PURE__ */ new Set();
  return function(r, a) {
    n && clearTimeout(n), r.forEach(({ target: s }) => i.add(s)), n = setTimeout(() => {
      t(i, a), n = null;
    }, e);
  };
}, ta = (t) => {
  t.forEach((e) => ea(e)), t.clear();
}, ea = (t) => {
  const e = (s) => t.setAttribute("sizes", (s | 0) + "px");
  let n = 0, i = 0, r = t;
  for (; n < 100 && r; )
    n = r.offsetWidth, i = r.offsetHeight, r = r.parentNode;
  if (getComputedStyle(t).objectFit !== "cover") return e(n);
  const a = Number(t.getAttribute("width")) / Number(t.getAttribute("height"));
  if (!a || n / i >= a + 0.1) return e(n);
  e(i * a);
}, tt = new ResizeObserver(Zr(ta, 800)), Le = (t, e, n) => {
  if (e) return ia(t);
  if (n) return na(t, n);
  throw new TypeError("Invalid options");
}, na = (t, e) => (t = new URL(t, document.baseURI).href, t.includes("localhost") ? () => t : (n) => (e + t).replace("{width}", String(n))), ia = (t) => {
  if (t.includes("{width}")) return (e) => t.replaceAll("{width}", String(e));
  if (_e.test(t)) {
    const e = t.replace(_e, "_{width}x$1");
    return (n) => e.replaceAll("{width}", String(n));
  }
  return (e) => {
    const n = new URL(t, document.baseURI);
    return n.searchParams.set("width", String(e)), n.href;
  };
}, ra = [
  180,
  360,
  540,
  720,
  900,
  1080,
  1296,
  1512,
  1728,
  1944,
  2160,
  2376,
  2592,
  2808,
  3024
], Ae = (t, e = 1 / 0) => ra.filter((n) => n <= e).map((n) => `${t(n)} ${n}w`).join(","), _e = /_\d+x(\.jpg|\.png)/;
function aa(t) {
  const { autoSize: e = !0, shopify: n = !1, maxSize: i = 0, cloudURL: r = "" } = sa(t) ?? {};
  return (a) => {
    a.directive("rias", (o, { expression: l }, { effect: c, evaluateLater: u, cleanup: d }) => {
      if (!(o instanceof HTMLImageElement)) return console.warn("x-rias only works on img elements");
      if (d(() => tt.unobserve(o)), !l) return e && tt.observe(o);
      const m = u(l);
      c(() => {
        m((v) => {
          if (!v || typeof v != "string") return;
          const p = Le(v, n, r), b = i || Number(o.dataset.maxSize) || 1 / 0, g = p(Math.min(b, 360)), w = Ae(p, b);
          a.mutateDom(() => {
            o.src = g, o.srcset = w, o.loading = o.loading == "eager" ? "eager" : "lazy", (e || o.dataset.sizes == "auto") && tt.observe(o);
          });
        });
      });
    });
    const s = {
      srcset(o) {
        return Ae(Le(o, n, r), i || 1 / 0);
      },
      observe: tt.observe.bind(tt),
      unobserve: tt.unobserve.bind(tt)
    };
    a.magic("rias", () => s);
  };
}
var sa = (t) => {
  if (typeof t == "string") return { cloudURL: `https://res.cloudinary.com/${t}/image/fetch/f_auto,q_80,w_{width}/` };
  if (typeof t == "object") return {
    ...t,
    cloudURL: t.key ? `https://res.cloudinary.com/${t.key}/image/fetch/f_auto,q_80,w_{width}/` : ""
  };
}, oa = (t) => {
  t.addRootSelector(() => `[${t.prefixed("data-async")}]`);
  const e = "data-async", n = t.prefixed("ignore"), i = {}, r = /* @__PURE__ */ new WeakSet(), a = (s, { expression: o }, { evaluateLater: l, evaluate: c, cleanup: u }) => {
    r.has(s) || (r.add(s), l(o)((d) => {
      if (typeof d != "object" || d === null) throw new Error(`alpine.js Async directive expected an object, but received: ${typeof d}`);
      [!0, void 0].includes(d) && (d = {});
      const m = t.reactive(d), v = t.addScopeToNode(s, m);
      m.init && c(m.init), u(() => {
        m.destroy && c(m.destroy), v();
      }), delete s._x_ignore, s.removeAttribute(n), t.initTree(s);
    }, { scope: i }));
  };
  a.inline = (s, { expression: o }) => {
    r.has(s) || (s._x_ignore = !0, s.setAttribute(n, ""));
  }, t.directive(e, a).before("ignore"), t.asyncData = (s, o) => {
    i[s] = async (...l) => {
      const [c, u] = o.split("?");
      try {
        const d = await import(c);
        if (u && u in d) return d[u](...l);
        if (s in d) return d[s](...l);
        if (d.default && typeof d.default == "function") return d.default(...l);
        if (typeof d == "function") return d(...l);
        throw new Error(`Async Data: Module ${o} does not export a function named ${s}, or a default function.`);
      } catch (d) {
        return console.error("Async Data Loader Error while looking for:", s, o), console.error(d), {};
      }
    };
  };
}, la = (t) => {
  t.directive("clickable", (i, { expression: r }, { cleanup: a }) => {
    const s = i.querySelector(r || "a, button");
    if (!s) return console.warn(`x-clickable: No target found for selector ${r || "a, button"}`);
    const o = function(l) {
      const c = l.target;
      !(c instanceof HTMLElement) || e(c, i) !== i || n(s, l.constructor, l);
    };
    a(t.bind(i, {
      "@click": o,
      "@auxclick": o
    }));
  });
  const e = (i, r) => t.findClosest(i, (a) => a.matches("a, button, input, select") || a === r), n = (i, r = MouseEvent, a) => i.dispatchEvent(new r("click", a));
}, ca = class {
  el;
  details;
  get id() {
    return this.el.id;
  }
  closing = !1;
  opening = !1;
  backdrop;
  keyboard;
  constructor(t, e, n) {
    this.el = t, this.details = n, this.backdrop = e.backdrop, this.keyboard = e.keyboard;
  }
  withDetails(t) {
    return t && (this.details = t), this;
  }
  async open() {
    return this.el.open ? this : (this.opening = !0, this.el.dispatchEvent(new CustomEvent("dialog-opening", {
      detail: this,
      bubbles: !0
    })), this.el.showModal(), await this.el.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 200 }).finished, this.el.dispatchEvent(new CustomEvent("dialog-opened", {
      detail: this,
      bubbles: !0
    })), this.opening = !1, this);
  }
  async close() {
    return this.el.open ? (this.closing = !0, this.el.dispatchEvent(new CustomEvent("dialog-closing", {
      detail: this,
      bubbles: !0
    })), await this.el.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 200 }).finished, this.el.close(), this.el.dispatchEvent(new CustomEvent("dialog-closed", {
      detail: this,
      bubbles: !0
    })), this.closing = !1, this) : this;
  }
}, ua = class extends EventTarget {
  Alpine;
  availableDialogs = /* @__PURE__ */ new Map();
  active = null;
  constructor(t) {
    super(), this.Alpine = t;
  }
  get isActive() {
    return !!this.active;
  }
  get id() {
    return this.active?.el.id;
  }
  get details() {
    return this.active?.details;
  }
  open(t, e) {
    if (t === this.active?.el.id) return this;
    this.active && this.close(this.active);
    const n = this.availableDialogs.get(t) ?? null;
    return n ? (this.active = n, n.withDetails(e).open(), this.dispatchEvent(new CustomEvent("dialog-opened", { detail: n })), this) : (console.error(`Modal with id "${t}" does not exist`), this);
  }
  close(t) {
    const e = t ?? this.active;
    return e ? (e.close().then((n) => n === this.active && (this.active = null)), this.dispatchEvent(new CustomEvent("dialog-closed", { detail: e })), this) : (console.log(t, e, "there is no active"), this);
  }
  setOptions(t) {
    return this.active && Object.assign(this.active, t), this;
  }
  isRegistered(t) {
    return this.availableDialogs.has(t);
  }
  unregister(t) {
    return this.availableDialogs.delete(t), this.active?.id === t && (this.active = null), this;
  }
  create(t, e, n) {
    const i = this.Alpine.reactive(new ca(t, e, n));
    return this.availableDialogs.set(i.id, i), i;
  }
}, da = (t) => {
  const e = new ua(t);
  t.addRootSelector(() => `[${t.prefixed("dialog")}]`), t.directive("dialog", (n, { expression: i }, { evaluate: r, cleanup: a }) => {
    if (!(n instanceof HTMLDialogElement)) return console.error("x-modal must be on a <dialog> element", n);
    const s = n.id;
    console.assert(!!s, "x-dialog element must have an ID: %o", n);
    const { backdrop: o = !0, keyboard: l = !0 } = i ? r(i) : {}, c = e.create(n, {
      backdrop: o,
      keyboard: l
    });
    a(t.addScopeToNode(n, { $dialog: c })), a(e.unregister.bind(e, s)), a(t.bind(n, {
      "@click.self"() {
        c.backdrop && e.close(c);
      },
      "@cancel.prevent.stop"() {
        c.keyboard && e.close(c);
      },
      "@dialog-closed.self"(u) {
        u.detail === c && c === e.active && (e.active = null, e.dispatchEvent(new CustomEvent("dialog-closed", { detail: c })));
      },
      "@keydown.escape.prevent.stop"() {
        c.keyboard && e.close(c);
      },
      ":class"() {
        return {
          "dialog-out backdrop:animate-fade-out": c.closing,
          "dialog-in backdrop:animate-fade-in": c.opening
        };
      }
    }));
  }), t.magic("dialogs", () => e), t.$dialogs = e;
}, It = /* @__PURE__ */ (function(t) {
  return t.Up = "up", t.Down = "down", t;
})(It || {}), fa = (t) => {
  const e = /* @__PURE__ */ new Set(), n = t.reactive({
    previous: window.scrollY,
    current: window.scrollY,
    nearTop: window.scrollY < 120,
    direction: It.Up,
    onScroll: (r) => (e.add(r), () => e.delete(r))
  });
  let i;
  n.onScroll((r) => {
    const a = r.current > r.previous ? It.Down : It.Up;
    a !== n.direction ? i ??= setTimeout(() => n.direction = a, 200) : (clearTimeout(i), i = void 0);
  }), window.addEventListener("scroll", () => {
    n.previous = n.current, n.current = window.scrollY, n.nearTop = window.scrollY <= 90 ? !0 : window.scrollY >= 120 ? !1 : n.nearTop, e.forEach((r) => r(n));
  }, { passive: !0 }), t.$scroll = n, t.magic("scroll", () => n);
}, $ = /* @__PURE__ */ Symbol("$slider"), pn = (t) => $ in t, ha = {
  ":disabled"() {
    return this[$].isLast;
  },
  "x-on:click"() {
    this[$].next(this.$el);
  }
}, ma = {
  ":disabled"() {
    return this[$].isFirst;
  },
  "x-on:click"() {
    this[$].prev(this.$el);
  }
}, va = (t) => ({
  ":disabled"() {
    return this[$].focusedIndex === t;
  },
  "x-on:click"() {
    this[$].scrollTo(t);
  }
}), pa = {
  "x-on:mouseenter"() {
    this[$].pause();
  },
  "x-on:mouseleave"() {
    this[$].unpause();
  },
  "x-on:focusin"() {
    this[$].pause();
  },
  "x-on:focusout"() {
    this[$].unpause();
  }
}, ga = { ":style"() {
  const t = this[$].focusedSize;
  return {
    maxHeight: t ? `${t}px` : "max-content",
    transition: "max-height 300ms"
  };
} }, ba = {
  "x-intersect.threshold.60"() {
    this.visible = !0;
    const t = this[$];
    this.index = t.indexOfItem(this.$el) ?? 0, t.handleIntersect(this.$el);
  },
  "x-intersect:leave.threshold.40"() {
    this.visible = !1;
    const t = this[$];
    this.index = t.indexOfItem(this.$el) ?? 0, t.handleIntersect(this.$el, !1);
  },
  "x-init"() {
    this[$].onLoad(this.$el);
  },
  "x-on:load"() {
    this[$].onLoad(this.$el);
  },
  "x-data"() {
    return {
      visible: !1,
      index: 0
    };
  },
  ":class"() {
    const t = this[$], e = this.index, n = t.focusedIndex;
    return {
      "slide-item": !0,
      "slide-next": e > n,
      "slide-previous": e < n,
      "slide-current": e === n,
      "slide-visible": this.visible
    };
  }
}, ya = {
  "x-intersect:enter.threshold.60"() {
    this.$el.removeAttribute("tabindex"), this.$el.removeAttribute("inert");
  },
  "x-intersect:leave.threshold.40"() {
    this.$el.setAttribute("tabindex", "-1"), this.$el.setAttribute("inert", "inert");
  }
}, wa = (t, e, n, { Alpine: i, cleanup: r }) => {
  const a = i.$data(e);
  if (!pn(a)) {
    console.error(`Element with ${n.original} needs to be inside an x-slider element`, e);
    return;
  }
  const s = a[$];
  if (s.components.set(t, e), t === "gallery") {
    const o = new AbortController(), l = s.updateEdges.bind(s);
    e.addEventListener("scroll", l, {
      passive: !0,
      signal: o.signal
    });
    const c = new ResizeObserver(l), u = new MutationObserver(l);
    c.observe(e), u.observe(e, { childList: !0 }), r(() => {
      o.abort(), c.disconnect(), u.disconnect();
    }), s.updateEdges();
  }
}, et = (t) => Array.from(t.children).flatMap((e) => getComputedStyle(e).display === "contents" ? et(e) : e).filter((e) => e.nodeName !== "TEMPLATE" && getComputedStyle(e).display !== "none"), xa = (t, e) => {
  let n = 0, i = Number.POSITIVE_INFINITY;
  for (let r = 0; r < t.length; r++) {
    const a = Math.abs(t[r] - e);
    if (a >= i) return n;
    i = a, n = r;
  }
  return n;
}, Ea = (t, e, n, i = 1) => {
  const r = e - n;
  return {
    atStart: t <= i,
    atEnd: t >= r - i
  };
}, Sa = (t) => t instanceof HTMLImageElement, Ta = (t, { expression: e }, { evaluate: n, cleanup: i, Alpine: r }) => {
  const a = Object.assign({
    scrollToDepth: 0,
    intoView: !1,
    centerVertically: !1,
    autoScroll: 0,
    autoInitialize: !1,
    animated: !1
  }, e ? n(e) : {}), s = r.reactive({
    focusedIndex: 0,
    focusedSize: 0,
    initialized: !!a.autoInitialize,
    touched: !1,
    paused: !1,
    atStart: !0,
    atEnd: !1,
    pause() {
      return this.paused = !0, this;
    },
    unpause() {
      return this.paused = !1, this;
    },
    components: /* @__PURE__ */ new Map(),
    autoScrollPercentage: 1,
    init() {
      if (a.autoScroll) {
        const o = new ka(a.autoScroll).onTick((l) => {
          this.autoScrollPercentage = l;
        }).onFinish(() => {
          if (this.touched) return o.abort();
          if (this.paused) return;
          const l = this.components.get("gallery");
          l && this.scrollTo($n(this.focusedIndex + 1, et(l).length));
        });
        i(() => o.abort());
      }
    },
    onLoad(o) {
      if (this.initialized || Sa(o) && !o.complete) return;
      this.focusedIndex = 0, this.focusedSize = this.itemAtIndex(0)?.clientHeight || 0;
      const l = this.components.get("gallery");
      l && (l.scrollLeft = 0), this.initialized = !0, this.init(), this.updateEdges();
    },
    handleIntersect(o, l = !0) {
      if (!this.initialized) return;
      const c = this.components.get("gallery");
      if (l && (!c || a.animated)) {
        this.focusedIndex = this.indexOfItem(o) ?? 0, this.focusedSize = o.clientHeight;
        return;
      }
      this.updateFocusedIndex(), this.updateEdges();
    },
    updateFocusedIndex() {
      const o = this.components.get("gallery");
      if (!o) return;
      const l = et(o), c = parseFloat(getComputedStyle(o).scrollPaddingLeft) || 0, u = l.map((m) => ot(HTMLElement, m)?.offsetLeft ?? 0), d = xa(u, o.scrollLeft + c);
      this.focusedIndex = d, this.focusedSize = ot(HTMLElement, l[d])?.clientHeight ?? t.clientHeight;
    },
    itemAtIndex(o) {
      const l = this.components.get("gallery");
      if (!l) return;
      const c = et(l);
      let u = c[An(o, c.length - 1)];
      if (u !== void 0) {
        for (let d = 0; d < a.scrollToDepth; d++) u = u?.firstElementChild ?? u;
        return u?.closest("template") ? this.itemAtIndex(o + 1) : u;
      }
    },
    indexOfItem(o) {
      const l = this.components.get("gallery");
      if (!l) return;
      const c = et(l);
      for (let u = 0; u < c.length; u++) if (c[u].contains(o)) return u;
    },
    async scrollTo(o, l = 0, c = !1, u = !1) {
      const d = this.components.get("gallery");
      if (!d) return;
      const m = o instanceof Element ? o : this.itemAtIndex(o);
      if (!m) return;
      c && (this.touched = !0);
      const v = typeof o == "number" ? o : this.indexOfItem(m) ?? this.focusedIndex;
      this.initialized || (this.initialized = !0, await Fn()), u || a.animated ? this.focusedIndex = v : this.focusedIndex += Math.sign(v - this.focusedIndex), a.animated || (window.scrollBy({ top: 0.5 }), window.scrollBy({ top: -0.5 }), a.intoView ? m.scrollIntoView({
        behavior: "smooth",
        block: a.centerVertically ? "center" : "nearest",
        inline: "center"
      }) : (u && (d.style.scrollBehavior = "auto"), d.scrollLeft = o === 0 ? 0 : (ot(HTMLElement, m)?.offsetLeft ?? 0) - l, u && (d.style.scrollBehavior = null)));
      const p = this.components.get("thumbnails");
      if (!p) return;
      const b = ot(HTMLElement, p.children[v]);
      b && p.scrollTo({
        top: b.offsetTop - (p.clientHeight - b.clientHeight) / 2,
        left: b.offsetLeft - (p.clientWidth - b.clientWidth) / 2,
        behavior: "smooth"
      });
    },
    updateEdges() {
      const o = this.components.get("gallery");
      if (!o || a.animated) return;
      const { atStart: l, atEnd: c } = Ea(o.scrollLeft, o.scrollWidth, o.clientWidth);
      this.atStart = l, this.atEnd = c;
    },
    get isFirst() {
      return a.animated ? this.focusedIndex === 0 : this.atStart;
    },
    get isLast() {
      const o = this.components.get("gallery");
      return o ? a.animated ? this.focusedIndex === et(o).length - 1 : this.atEnd : !0;
    },
    get itemCount() {
      const o = this.components.get("gallery");
      return o ? et(o).length : 0;
    },
    next(o) {
      const l = this.getStepInfo(o);
      this.scrollTo(Math.max(0, this.focusedIndex + l), 10, !0);
    },
    prev(o) {
      const l = this.getStepInfo(o);
      this.scrollTo(Math.max(0, this.focusedIndex - l), 10, !0);
    },
    getStepInfo(o) {
      const l = getComputedStyle(o);
      let c = parseInt(l.getPropertyValue("--perpage") || "1");
      const u = l.getPropertyValue("--arrow-step").trim(), d = this.components.get("gallery");
      if (d && u === "view") {
        const m = ot(HTMLElement, this.itemAtIndex(0)), v = ot(HTMLElement, this.itemAtIndex(1)), p = m && v && m !== v ? Math.abs(v.offsetLeft - m.offsetLeft) : 0;
        p > 0 && (c = Math.max(1, Math.floor(d.clientWidth / p)));
      }
      return c;
    }
  });
  r.addScopeToNode(t, { [$]: s }), a.autoInitialize && s.init();
}, ka = class gn extends EventTarget {
  duration = 0;
  currentTime = 0;
  lastTimestep = 0;
  controller = new AbortController();
  get percentage() {
    return this.currentTime / this.duration;
  }
  constructor(e) {
    super(), this.duration = e, this.lastTimestep = performance.now(), requestAnimationFrame(this.ticker);
  }
  ticker = (e) => {
    if (this.controller.signal.aborted) return;
    const n = e - this.lastTimestep;
    this.lastTimestep = e, this.currentTime += n, this.dispatchEvent(new Event("tick")), this.currentTime > this.duration && (this.dispatchEvent(new Event("just-finished")), this.currentTime %= this.duration), requestAnimationFrame(this.ticker);
  };
  abort() {
    this.controller.abort();
  }
  onTick(e) {
    return this.addEventListener("tick", () => e(this.percentage), { signal: this.controller.signal }), this;
  }
  onFinish(e) {
    return this.addEventListener("just-finished", e, { signal: this.controller.signal }), this;
  }
  static fromSeconds(e) {
    return new gn(e * 1e3);
  }
}, Ca = (t) => {
  t.addRootSelector(() => `[${t.prefixed("slider")}]`), t.directive("slider", (e, n, i) => {
    if (!n.value || n.value === "root") return Ta(e, n, i);
    (n.value === "gallery" || n.value === "thumbnails") && wa(n.value, e, n, i);
  }), t.magic("slider", (e) => {
    const n = t.$data(e);
    if (pn(n)) return n[$];
  }), t.bind("$sliderDynamicHeight", ga), t.bind("$sliderItem", ba), t.bind("$sliderNext", ha), t.bind("$sliderPrev", ma), t.bind("$sliderGoTo", va), t.bind("$sliderPause", pa), t.bind("$sliderUnfocusHidden", ya);
}, Fe = (t, e, n = e) => {
  const { scrollPaddingTop: i, scrollPaddingBottom: r } = window.getComputedStyle(t);
  return {
    top: $e(i, e),
    bottom: $e(r, n)
  };
}, $e = (t, e) => t !== "auto" ? parseInt(t) : e, Ia = 100, Na = (t) => {
  t.addRootSelector(() => `[${t.prefixed("smartstick")}]`), t.directive("smartstick", (e, n, { cleanup: i }) => {
    let r = Fe(e, Ia);
    const a = t.reactive({
      top: 0,
      get topString() {
        return `${-1 * this.top + r.top}px`;
      }
    });
    let s = 0, o = window.scrollY;
    const l = () => {
      const p = window.scrollY, b = p - o;
      a.top = Math.min(s, Math.max(0, a.top + b)), o = p;
    }, c = () => {
      r = Fe(e, r.top, r.bottom), s = Math.max(0, e.clientHeight - window.innerHeight + r.top + r.bottom);
    }, u = new ResizeObserver(c);
    u.observe(e), window.addEventListener("resize", c);
    const d = window.matchMedia("(min-width: 1024px)"), m = (p) => window[p.matches ? "addEventListener" : "removeEventListener"]("scroll", l, { passive: !0 });
    d.addEventListener("change", m), m(d);
    const v = t.effect(() => e.style.top = a.topString);
    i(() => {
      t.release(v), u.disconnect(), d.removeEventListener("change", m), window.removeEventListener("resize", c), window.removeEventListener("scroll", l);
    });
  });
}, oe = (t, e, n) => {
  const i = /* @__PURE__ */ new WeakMap();
  return (r) => {
    r.addRootSelector(() => `[${r.prefixed(t)}]`);
    const a = (s) => {
      const o = r.findClosest(s, i.has.bind(i));
      if (!o) return console.error(`Could not find root for ${t} component`, s);
      if (o instanceof HTMLElement) return i.get(o);
    };
    r.magic(t, (s) => a(s)), r.directive(t, (s, o, l) => {
      if (!o.value) return i.set(s, e(s, o, l));
      const c = a(s);
      if (!c) return La(t, s);
      (n?.[o.value] || Oa(t))(c, s, o, l);
    });
  };
}, Oa = (t) => (e, n, i) => {
  console.error(`Alpine ${t}: Invalid directive value`, n, i.original);
}, La = (t, e) => console.error(`Could not find root for ${t} component`, e), Nt = /* @__PURE__ */ new WeakMap(), Aa = (t, e) => {
  const n = e.findClosest(t, Nt.has.bind(Nt));
  if (n instanceof HTMLElement) return Nt.get(n);
}, _a = (t, e, { Alpine: n, effect: i }) => {
  const r = n.reactive({
    active: null,
    id: 0,
    addAccordion(a) {
      const s = this.id++, o = n.reactive({ active: a });
      return i(() => {
        o.active ? this.active = s : this.active === s && (this.active = null);
      }), i(() => {
        this.active === s ? o.active = !0 : o.active = !1;
      }), o;
    }
  });
  return Nt.set(t, r), r;
}, Fa = (t) => {
  t.addRootSelector(() => `[${t.prefixed("accordion-group")}]`), t.directive("accordion-group", _a);
}, $a = (t, { modifiers: [e = "closed"] }, { Alpine: n }) => Aa(t, n)?.addAccordion(e === "open") ?? n.reactive({ active: e === "open" }), Ra = {
  open: !0,
  close: !1,
  toggle: null
}, Da = (t, e, { modifiers: [n = "toggle"] }, { Alpine: i }) => {
  i.bind(e, {
    "x-on:click": () => {
      t.active = Ra[n] ?? !t.active;
    },
    ":aria-expanded": () => t.active
  });
}, Ma = (t, e, n, { Alpine: i }) => {
  i.bind(e, { "x-show": () => t.active });
}, Pa = {
  control: Da,
  container: Ma
}, qa = oe("accordion", $a, Pa), ja = (t) => {
  Fa(t), qa(t);
}, bn = () => new Promise((t) => queueMicrotask(() => setTimeout(t))), Re = new ResizeObserver((t) => {
  for (const e of t) {
    const n = e.target;
    n instanceof HTMLElement && Ba(n);
  }
}), Ba = async (t) => {
  await bn(), t.scrollLeft = (t.scrollWidth - t.clientWidth) / 2, t.scrollTop = (t.scrollHeight - t.clientHeight) / 2;
}, De = Array.prototype.forEach, Ha = (t) => t.directive("dragscroll", (e, { modifiers: n }, { cleanup: i }) => {
  const r = n.includes("center");
  i(Va(e)), e.classList.add("overscroll-contain", "cursor-grab"), r && (De.call(e.children, (a) => Re.observe(a)), i(() => De.call(e.children, (a) => Re.unobserve(a))));
}), mt = (t) => {
  t.preventDefault(), t.stopPropagation();
}, Me = [
  "pointerup",
  "mouseup",
  "touchend"
], Va = (t) => {
  const e = (r) => {
    mt(r), t.scrollLeft -= r.movementX, t.scrollTop -= r.movementY;
  }, n = async (r) => {
    mt(r), document.removeEventListener("pointermove", e, !0), document.body.classList.remove("!cursor-grabbing", "[&>*]:pointer-events-none"), t.classList.add("cursor-grab"), await bn(), document.removeEventListener("click", mt, !0), Me.forEach((a) => {
      document.removeEventListener(a, n, { capture: !0 });
    });
  }, i = (r) => {
    za(r) || r.button !== 2 && (mt(r), t.classList.remove("cursor-grab"), document.body.classList.add("!cursor-grabbing", "[&>*]:pointer-events-none"), document.addEventListener("pointermove", e, { capture: !0 }), Me.forEach((a) => document.addEventListener(a, n, { capture: !0 })), document.addEventListener("click", mt, { capture: !0 }));
  };
  return t.addEventListener("pointerdown", i), () => t.removeEventListener("pointerdown", i);
}, za = (t) => t instanceof TouchEvent || t instanceof PointerEvent && t.pointerType === "touch", Ka = (t, e, { Alpine: n }) => {
  const i = n.reactive({
    root: t,
    isOpen: !1,
    open() {
      this.isOpen = !0;
    },
    close() {
      this.isOpen = !1;
    },
    toggle() {
      return this.isOpen ? this.close() : this.open();
    }
  });
  return n.bind(t, { "x-id": () => ["x-panel"] }), i;
}, Wa = oe("panel", Ka, {
  summary: (t, e, n, { Alpine: i }) => {
    i.bind(e, {
      ":aria-expanded": () => t.isOpen,
      ":aria-controls": '$id("x-panel")'
    });
  },
  content: (t, e, n, { Alpine: i }) => {
    i.bind(e, {
      "x-show": () => t.isOpen,
      ":id": '$id("x-panel")'
    });
  }
}), Ua = oe("tabs", (t, e, { Alpine: n, evaluate: i }) => n.reactive({
  activeTab: 0,
  tabs: [],
  panels: [],
  $focus: i("$focus"),
  isSelected(r) {
    return this.tabs[this.activeTab] === r;
  },
  activate(r) {
    this.activeTab = r, n.nextTick(() => this.panels[r]?.dispatchEvent(new CustomEvent("tab-activated")));
  }
}), {
  list: (t, e, n, { Alpine: i }) => {
    const r = () => t.$focus.wrap().next(), a = () => t.$focus.wrap().previous();
    i.bind(e, {
      ":role": () => "tablist",
      "@keydown.arrow-left.stop.prevent": a,
      "@keydown.arrow-right.stop.prevent": r,
      "@keydown.arrow-up.stop.prevent": a,
      "@keydown.arrow-down.stop.prevent": r
    });
  },
  tab: (t, e, n, { Alpine: i }) => {
    const r = t.tabs.push(e) - 1, a = () => t.activate(r);
    i.bind(e, {
      ":tabindex": () => Number(t.isSelected(e)) - 1,
      ":aria-selected": () => t.isSelected(e),
      "@click": a,
      "@keydown.space.stop.prevent": a,
      "@keydown.enter.stop.prevent": a
    });
  },
  panel: (t, e, n, { Alpine: i }) => {
    const r = t.panels.push(e) - 1;
    i.bind(e, {
      ":tab-index": () => Number(t.isSelected(e)) - 1,
      ":aria-hidden": () => !t.isSelected(e),
      ":class"() {
        if (r === t.activeTab) return "panel-current";
        if (r > t.activeTab) return "panel-next";
        if (r < t.activeTab) return "panel-previous";
      }
    });
  }
}), Vt = /* @__PURE__ */ (function(t) {
  return t[t.None = 0] = "None", t[t.Left = 1] = "Left", t[t.Right = 2] = "Right", t[t.Up = 4] = "Up", t[t.Down = 8] = "Down", t;
})(Vt || {}), yt = /* @__PURE__ */ new WeakMap(), Ga = yt.has.bind(yt), Ya = (t) => t.directive("swipe", (e, n, { cleanup: i }) => {
  yt.set(e, { dispatch: (r) => {
    const a = Object.entries(Vt).filter(([, s]) => typeof s == "number" && s && (r & s) === s).map(([s]) => s.toLowerCase());
    e.dispatchEvent(new CustomEvent("swipe", { detail: a.join("-") })), e.dispatchEvent(new CustomEvent(`swipe${a.join("")}`, { detail: a.join("-") }));
  } }), e.addEventListener("touchstart", Pe), i(() => e.removeEventListener("touchstart", Pe));
}), Pe = (t) => {
  const e = yt.get(t.currentTarget);
  if (!e) return;
  const { clientX: n, clientY: i } = t.touches[0];
  e.start ??= {
    x: n,
    y: i
  }, document.addEventListener("touchend", Ja, { once: !0 });
}, Ja = (t) => {
  const e = t.target;
  if (!e) return;
  const n = yt.get(yn(e, Ga));
  if (!n?.start) return;
  const { clientX: i, clientY: r } = t.changedTouches[0], a = Xa(n.start, {
    x: i,
    y: r
  });
  a !== Vt.None && (n.dispatch(a), delete n.start);
}, yn = (t, e) => e(t) ? t : t.parentElement ? yn(t.parentElement, e) : null, Xa = (t, e) => {
  const n = [e.x - t.x, e.y - t.y];
  if (n.every((s) => Math.abs(s) < 50)) return Vt.None;
  const i = Math.sqrt(n[0] * n[0] + n[1] * n[1]), [r, a] = n.map((s) => s / i);
  return qe(r) | qe(a) << 2;
}, qe = (t) => t > 0.5 ? 2 : t < -0.5 ? 1 : 0, Qa = (t) => {
  t.magic("screen", () => (e) => {
    const n = typeof e == "number" ? e : Za[e] ?? Number(e);
    return n ? ts(n, t).value : (console.error(`Invalid breakpoint: $screen(${JSON.stringify(e)})`), !1);
  });
}, Za = {
  xs: 320,
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  "2xl": 1536
}, wn = {}, ts = (t, e) => wn[t] ?? es(t, e), es = (t, e) => {
  const n = window.matchMedia(`(min-width: ${t}px)`), i = e.reactive({ value: n.matches });
  return wn[t] = i, n.addEventListener("change", (r) => {
    i.value = r.matches;
  }), i;
}, ns = (t) => t.plugin([Qa]), is = (t) => t.plugin([
  ja,
  Ha,
  Wa,
  Ya,
  Ua,
  ns
]), rs = (t) => {
  t.magic("abortSignal", (e, { cleanup: n }) => {
    const i = new AbortController();
    return n(() => i.abort("Alpine Component has been Removed")), i.signal;
  });
}, as = (t) => {
  t.magic("dataset", (e) => e.dataset), t.magic("formatMoney", () => window.NewThink?.ACCESS_GATE_SHOW_PRICES === !1 ? () => "" : Sn);
}, ss = (t) => {
  t.bind("hideOverflow", {
    "x-data": "{ visible: true }",
    ":class": "{ 'pointer-events-none invisible': !visible }",
    "x-intersect:leave.threshold.99.margin.1000.0": "visible = false",
    "x-intersect:enter.threshold.99.margin.1000.0": "visible = true"
  });
}, os = (t) => {
  t.directive("inert-trap", (e, { expression: n, modifiers: i }, { evaluateLater: r, effect: a }) => {
    const s = i.includes("retain"), o = i.includes("noscroll"), l = i.includes("return"), c = i.includes("header"), u = r(n), d = [];
    let m = null;
    a(() => {
      u((v) => {
        if (v) {
          m = document.activeElement;
          for (const p of cs(e, ...document.querySelectorAll("[role=alertdialog]"), ...c ? document.querySelectorAll("[data-site-header]") : [], s ? m?.closest("[data-retain-focus-from]") ?? m : null))
            p.setAttribute("inert", "inert"), d.push(p);
          o && document.documentElement.setAttribute("data-scroll-lock", "");
        } else {
          for (const p of d) p.removeAttribute("inert");
          d.length = 0, o && document.documentElement.removeAttribute("data-scroll-lock"), l && m && (ls(e, m), m = null);
        }
      });
    });
  });
};
function ls(t, e) {
  const n = document.activeElement;
  n && n !== document.body && !t.contains(n) || [e, ...document.querySelectorAll(`[aria-controls="${t.id}"]`)].find((i) => i instanceof HTMLElement && i !== document.body && i.getClientRects().length > 0)?.focus();
}
function cs(...t) {
  return t = t.filter((e) => e !== null), document.createTreeWalker(document.body, NodeFilter.SHOW_ELEMENT, (e) => {
    if (!(e instanceof HTMLElement) || e.matches("[inert] > *") || t.includes(e)) return NodeFilter.FILTER_REJECT;
    for (const n of t) if (e.contains(n)) return NodeFilter.FILTER_SKIP;
    return NodeFilter.FILTER_ACCEPT;
  });
}
TreeWalker.prototype[Symbol.iterator] ??= function* () {
  let t = this.nextNode();
  for (; t; )
    yield t, t = this.nextNode();
};
var us = (t) => {
  t.directive("highlight-scroll", (e, { expression: n }, { cleanup: i }) => {
    const r = n.trim();
    if (!r) {
      console.warn("Alpine.js: v-highlight-scroll requires a class name to highlight.");
      return;
    }
    const a = e.firstChild;
    if (!a || !(a instanceof Text)) {
      console.warn("Alpine.js: v-highlight-scroll requires a text node as the first child.");
      return;
    }
    const s = (a.textContent?.trim().split("") ?? []).map((c) => {
      const u = document.createElement("span");
      return u.textContent = c, u.classList.add(r), u;
    });
    a.replaceWith(...s);
    let o = -1;
    const l = setInterval(() => {
      o == -1 ? s.forEach((c) => c.classList.remove(r)) : s[o]?.classList.remove(r), o += 1, o %= s.length, s[o]?.classList.add(r);
    }, 500);
    i(() => clearInterval(l));
  }), t.addInitSelector(() => t.prefixed("highlight-scroll"));
}, je = {
  linear: (t) => t,
  easeOut: (t) => 1 - (1 - t) ** 3,
  easeInOut: (t) => t < 0.5 ? 2 * t * t : 1 - (-2 * t + 2) ** 2 / 2
}, xn = (t) => t === document.scrollingElement || t === document.documentElement, ds = (t) => {
  let e = t.parentElement;
  for (; e; ) {
    const { overflowY: n } = getComputedStyle(e);
    if ((n === "auto" || n === "scroll") && e.scrollHeight > e.clientHeight) return e;
    e = e.parentElement;
  }
  return document.scrollingElement ?? document.documentElement;
}, fs = (t, e, { block: n = "center", offset: i = 0 }) => {
  const { top: r, height: a } = t.getBoundingClientRect(), s = xn(e) ? 0 : e.getBoundingClientRect().top + e.clientTop, o = n === "start" ? 0 : n === "end" ? e.clientHeight - a : (e.clientHeight - a) / 2;
  return Math.max(0, Math.min(e.scrollTop + r - s - o + i, e.scrollHeight - e.clientHeight));
}, Yt = /* @__PURE__ */ new WeakMap(), Be = (t, e = {}) => {
  const { duration: n = 700, easing: i = "easeOut" } = e, r = ds(t);
  Yt.get(r)?.();
  const a = r.scrollTop, s = fs(t, r, e) - a;
  if (Math.abs(s) < 1) return;
  const o = (b) => r.scrollTo({
    top: b,
    behavior: "instant"
  });
  if (n <= 0 || matchMedia("(prefers-reduced-motion: reduce)").matches) return o(a + s);
  const l = je[i] ?? je.easeOut, c = new AbortController();
  let u = 0, d = null;
  const m = () => {
    cancelAnimationFrame(u), c.abort(), Yt.delete(r);
  }, v = (b) => {
    d ??= b;
    const g = Math.min((b - d) / n, 1);
    o(a + s * l(g)), g < 1 ? u = requestAnimationFrame(v) : m();
  }, p = xn(r) ? window : r;
  for (const b of ["wheel", "touchstart"]) p.addEventListener(b, m, {
    passive: !0,
    signal: c.signal
  });
  Yt.set(r, m), u = requestAnimationFrame(v);
}, hs = (t) => {
  t.magic("smoothScroll", (e) => (n = e, i = {}) => n instanceof Element ? Be(n, i) : Be(e, n));
}, ms = [
  rs,
  ar,
  oa,
  la,
  or,
  Pr,
  da,
  os,
  Kr,
  ss,
  Qr,
  aa({
    shopify: !0,
    autoSize: !0
  }),
  us,
  hs,
  Ca,
  Na,
  fa,
  is,
  as
], vs = (t) => t.store("mobileMenu", {
  visible: !1,
  show() {
    this.visible = !0, t.store("search").isOpen = !1;
  },
  hide() {
    this.visible = !1;
  },
  toggle() {
    this.visible ? this.hide() : this.show();
  }
}), ps = (t) => t.store("modal", {
  isOpen: !1,
  open() {
    this.isOpen = !0;
  },
  close() {
    this.isOpen = !1;
  }
}), gs = [
  Tn,
  vs,
  ps,
  kn
];
te.plugin([
  ...ms,
  ...gs,
  ...ki
]);
window.Alpine = te;
var bs = te, Ss = bs;
export {
  Ss as default
};
